var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Roster', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('Roster', {
            url: '/roster?:startDay',
            templateUrl: qmcBase + '/roster',
            controller: 'RosterController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Roster');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                }
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        class Constants {
        }
        Constants.SERVICE = "2db0eb84-7e2c-45c0-bde7-89d3fc7ba86b";
        Constants.SUBTYPE_PLANNED = "20f4990c-f722-4358-9a53-01e4c013a691";
        Constants.SUBTYPE_DOCUMENTED = "8762a244-16c8-412e-93b6-1e21f3c25222";
        Constants.SUBTYPE_DEVIATION = "fccf11f6-428e-4b65-9e31-18ace7bd0a00";
        Constants.DEVIATION_TYPE_BREAK = "9c5e119d-b2b7-46c7-a2a8-3b61176e106d";
        Constants.MISCELLANIOUS_TEMPLATE = '5d70cf86-cb00-4524-8ebd-02d43c754abf';
        Constants.SERVICE_WV_HOLIDAY = '370c3177-db5b-4673-bc9f-b49bc9e242c7';
        Constants.SERVICE_TYPE_HOLIDAY = '8bdf6a27-a881-4b4b-8abf-3bedb5156df2';
        Constants.SERVICE_SUBTYPE_HOLIDAY_HOLIDAY = 'be395209-7121-48f7-af6c-cb66563a1841';
        Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL = '105fcc3c-ed8f-405a-bc60-c32fd75bf14f';
        Constants.SERVICE_SUBTYPE_HOLIDAY_TRAINING = 'a7da1703-ef0d-4384-a868-c73e25683adb';
        Constants.SERVICE_WV_DISEASE = '122cef0e-ba67-4a69-aa5a-98aec16fb4f0';
        Constants.SERVICE_TYPE_DISEASE = 'dac03d14-8a88-4030-91db-ad65998986c2';
        Constants.SERVICE_SUBTYPE_DISEASE_STANDARD = '66783b01-9502-43db-a1af-9bbbcf48a1cf';
        Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT = '642bf8b1-f3a0-4755-9c66-b757f67f9d78';
        Constants.SERVICE_TYPE_EXEMPTION = '281aa8c1-340d-4ee3-979c-b8dc218a1a28';
        Constants.SERVICE_WV_EXEMPTION = 'e8feeb37-20cb-4a72-9b04-49f92fbd0dd4';
        Constants.SERVICE_SICKNOTETYPE_INITIALDOCUMENT = '37dd9194-a5b7-4055-a152-4aa0da30543b';
        Roster.Constants = Constants;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        let RosterService = class RosterService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Roster';
                ////////////////////////// SERVICE PLANNING //////////////////////////
                this.servicePlanningPath = "/Service";
                ////////////////////////// SICKLEAVE //////////////////////////
                this.sickLeavePath = "/SickLeave";
                this.sickNotePath = "/SickNote";
                ////////////////////////// Exemption //////////////////////////
                this.exemptionPath = "/Exemption";
            }
            getTemplates() {
                return super.get(this.modulePath + "/Template", {}, (data) => {
                    return data;
                });
            }
            getRosterWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            getReferences(objectType) {
                return super.get(this.modulePath + '/Reference', { objectType: objectType }, (data) => {
                    return data;
                });
            }
            getRosterData(referenceIds, referenceType, dateFrom, dateTo, predefinedView, includeSub = false, loadWorkingEventsData = true) {
                return super.getItem(this.modulePath, { referenceIds: referenceIds, referenceObjectType: referenceType, dateFrom: dateFrom, dateTo: dateTo, predefinedViewId: predefinedView, includeSub: includeSub, loadWorkingEventsData: loadWorkingEventsData }, (data) => {
                    return data;
                });
            }
            getAwayData(dateFrom, dateTo) {
                return super.get(this.modulePath + '/Away', { dateFrom, dateTo }, (data) => {
                    return data;
                });
            }
            postServicePlanning(data) {
                return super.post(this.modulePath + this.servicePlanningPath, data).then((d) => {
                    return d;
                });
            }
            postServiceDocu(id, data) {
                return super.post(this.modulePath + this.servicePlanningPath + "/" + id, data).then((d) => {
                    return d;
                });
            }
            putService(id, data) {
                return super.put(this.modulePath + this.servicePlanningPath + "/" + id, data).then((data) => {
                    return data;
                });
            }
            getService(id) {
                return super.getItem(this.modulePath + this.servicePlanningPath + "/" + id, {}, (d) => {
                    return d;
                });
            }
            deleteService(id) {
                return super.delete(this.modulePath + this.servicePlanningPath + '/' + id).then((data) => {
                    return data;
                });
            }
            checkForConflictErrors(data) {
                return super.post(this.modulePath + this.servicePlanningPath + '/Validation/', data).then((data) => {
                    return data;
                });
            }
            validateNonService(data) {
                return super.post(this.modulePath + this.servicePlanningPath + '/Validation/NewNonService', data).then((data) => {
                    return data;
                });
            }
            calculateDayValues(dateFrom, dateTo, referenceId) {
                return super.post(this.modulePath + this.servicePlanningPath + "/CalculateDayValues", { dateFrom, dateTo, referenceId }).then((data) => {
                    return data;
                });
            }
            ////////////////////////// SERVICE DEVIATION //////////////////////////
            serviceDeviationPath(serviceId) {
                return `${this.modulePath}${this.servicePlanningPath}/${serviceId}/Deviation`;
            }
            getDeviations(serviceId) {
                return super.get(this.serviceDeviationPath(serviceId), {}, (data) => data);
            }
            getDeviation(serviceId, id) {
                return super.getItem(`${this.serviceDeviationPath(serviceId)}/${id}`, {}, (data) => data);
            }
            postDeviation(serviceId, data) {
                return super.post(this.serviceDeviationPath(serviceId), data);
            }
            postDeviationsMultiple(serviceId, data) {
                return super.post(`${this.serviceDeviationPath(serviceId)}/Multiple`, data);
            }
            putDeviation(serviceId, id, data) {
                return super.put(`${this.serviceDeviationPath(serviceId)}/${id}`, data);
            }
            deleteDeviation(serviceId, id) {
                return super.delete(`${this.serviceDeviationPath(serviceId)}/${id}`);
            }
            validateDeviations(serviceId, data) {
                return super.post(`${this.serviceDeviationPath(serviceId)}/Validation`, data);
            }
            postSickLeave(data) {
                return super.post(this.modulePath + this.sickLeavePath, data).then((d) => {
                    return d;
                });
            }
            putSickLeave(id, data) {
                return super.put(this.modulePath + this.sickLeavePath + "/" + id, data).then((data) => {
                    return data;
                });
            }
            getSickLeave(id) {
                return super.getItem(this.modulePath + this.sickLeavePath + "/" + id, {}, (d) => {
                    return d;
                });
            }
            deleteSickLeave(id) {
                return super.delete(this.modulePath + this.sickLeavePath + '/' + id).then((data) => {
                    return data;
                });
            }
            getSickLeaveWv() {
                return super.getItem(this.modulePath + this.sickLeavePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            postSickNote(sickLeaveId, data) {
                return super.post(`${this.modulePath}${this.sickLeavePath}/${sickLeaveId}${this.sickNotePath}`, data).then((d) => {
                    return d;
                });
            }
            putSickNote(sickLeaveId, sickNoteId, data) {
                return super.put(`${this.modulePath}${this.sickLeavePath}/${sickLeaveId}${this.sickNotePath}/${sickNoteId}`, data).then((data) => {
                    return data;
                });
            }
            getSickNote(sickLeaveId, sickNoteId) {
                return super.getItem(`${this.modulePath}${this.sickLeavePath}/${sickLeaveId}${this.sickNotePath}/${sickNoteId}`, {}, (d) => {
                    return d;
                });
            }
            getSickNoteList(sickLeaveId) {
                return super.getItem(`${this.modulePath}${this.sickLeavePath}/${sickLeaveId}${this.sickNotePath}`, {}, (d) => {
                    return d;
                });
            }
            deleteSickNote(sickLeaveId, sickNoteId) {
                return super.delete(`${this.modulePath}${this.sickLeavePath}/${sickLeaveId}${this.sickNotePath}/${sickNoteId}`).then((data) => {
                    return data;
                });
            }
            postExemption(data) {
                return super.post(this.modulePath + this.exemptionPath, data).then((d) => {
                    return d;
                });
            }
            putExemption(id, data) {
                return super.put(this.modulePath + this.exemptionPath + "/" + id, data).then((data) => {
                    return data;
                });
            }
            getExemption(id) {
                return super.getItem(this.modulePath + this.exemptionPath + "/" + id, {}, (d) => {
                    return d;
                });
            }
            deleteExemption(id) {
                return super.delete(this.modulePath + this.exemptionPath + '/' + id).then((data) => {
                    return data;
                });
            }
            getExemptionWv() {
                return super.getItem(this.modulePath + this.exemptionPath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
        };
        RosterService = __decorate([
            QMC.Service('QMC.Roster', 'RosterService'),
            QMC.Inject('$http', '$q')
        ], RosterService);
        Roster.RosterService = RosterService;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        let RosterController = class RosterController {
            /////////////////////////// CONSTRUCTOR //////////////////////////
            constructor($location, rosterService, $qui, $scope, $stateParams, $state, lng, permissionService, clientService, userService, $compile, $timeout) {
                this.$location = $location;
                this.rosterService = rosterService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.clientService = clientService;
                this.userService = userService;
                this.$compile = $compile;
                this.$timeout = $timeout;
                //////////////////////////// VARIABLES ///////////////////////////
                this.supportMiscTemplates = [Roster.Constants.SERVICE_TYPE_HOLIDAY, Roster.Constants.SERVICE_TYPE_EXEMPTION, Roster.Constants.SERVICE_TYPE_DISEASE];
                this.localStorageItemName = "RosterSettings";
                this.isMobile = false;
                this.scrollPosition = 0;
                this.debounceCheckShowWeekends = false;
                this.debounceCheckHighlightWeekends = false;
                this.debounceCheckShowWorkingEventsInfo = false;
                this.debounceCheckSchedulerViewType = false;
                this.debounceCheck = false;
                this.calendarCreated = false;
                this.showValidationBox = false;
                this.calendarNoReload = false; //when removing a reference, no need to call the api for new data, just delete the reference from the calendar resources
                this.requestCache = {
                    references: {
                        requestType: undefined,
                        pendingKey: undefined,
                        lastKey: undefined,
                    },
                    rosterData: {
                        pendingKey: undefined,
                        lastKey: undefined,
                        lastRequestId: undefined,
                    },
                    referencePermission: {
                        pendingKey: undefined,
                        lastKey: undefined,
                    },
                };
                this.askDroppedService = QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE;
                this.institutes = [];
                this.employees = [];
                this.serviceAdditionals = [];
                this.serviceSubTypes = [];
                this.referenceTypes = [];
                this.references = [];
                this.predefinedViews = [];
                this.employeesList = [];
                this.rosterResources = [];
                this.rosterData = [];
                this.rosterEvents = [];
                this.isNegativeTimePeriodLock = false;
                this.resourceViewMobileCreated = false;
                this.loading = {
                    template: false, calendar: false, institute: false, employee: true, wv: false, referenceTypes: false, references: false, detail: false, permission: false,
                    allLoaded: () => {
                        return !(this.loading.template || this.loading.institute || this.loading.employee || this.loading.wv || this.loading.referenceTypes
                            || this.loading.references || this.loading.detail || this.loading.permission);
                    },
                };
                this.permission = {
                    view: false,
                    service: {
                        new: false,
                        modify: false,
                        delete: false
                    },
                    serviceDocumenteted: {
                        new: false,
                        modify: false,
                        delete: false,
                        openFile: false
                    }
                };
                this.servicePermission = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.schedulerViewTypes = [
                    { value: 'timeline', text: this.lng.translate(20028047, 'Zeitstrahl') },
                    { value: 'list', text: this.lng.translate(20028048, 'Liste') }
                ];
                this.rosterSettings = {
                    showWeekends: true,
                    showWorkingEventsInfo: true,
                    viewDate: new Date(),
                    dataFrom: new Date(),
                    dataTo: new Date(),
                    references: [],
                    predefinedView: QMC.Common.Constants.GUID_EMPTY,
                    referenceType: 120000,
                    defaultSchedulerView: 'Month',
                    schedulerViewType: 'timeline',
                    highlightWeekends: true,
                    includeSub: false,
                    showOnlyActiveReferences: true
                };
                this.dblClick = null;
                this.clickTimer = null;
                this.isDragging = false;
                this.formState = 'new';
                this.pendingDeviations = [];
                this.breakDeviationSummary = { minutes: 0 };
                ///////// Holiday
                this.holidayPermissions = { standard: undefined, special: undefined, approved: undefined, document: undefined, documentSpecial: undefined };
                this.holidayCallbacks = { onNew: () => this.getRosterData(true), onEdit: () => this.getRosterData(true), onDelete: () => this.getRosterData(true) };
                this.exemptionCallbacks = { onNew: () => this.getRosterData(true), onEdit: () => this.getRosterData(true), onDelete: () => this.getRosterData(true) };
                ///////// SickLeave
                this.sickLeavePermissions = { standard: undefined, accident: undefined, document: undefined };
                this.sickLeaveCallbacks = { onNew: () => this.getRosterData(true), onEdit: () => this.getRosterData(true), onDelete: () => this.getRosterData(true) };
                this.keepData = false;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.selectedReferences = [];
                const localStorageItem = QMC.Common.personalLocalStorage.getItem(this.localStorageItemName);
                const loadedFromStorage = localStorageItem !== null && localStorageItem !== "";
                const currentPersonId = $('#session').data().personId;
                if (loadedFromStorage) {
                    console.log(JSON.parse(localStorageItem).dataFrom);
                    this.rosterSettings = JSON.parse(localStorageItem);
                    this.rosterSettings.dataFrom = new Date();
                    this.rosterSettings.dataTo = new Date();
                    this.selectedReferences = this.rosterSettings.referenceType === 120000 ? this.rosterSettings.references : [];
                    this.selectedReference = this.rosterSettings.referenceType !== 120000 ? this.rosterSettings.references[0] : QMC.Common.Constants.GUID_EMPTY;
                }
                else {
                    this.rosterSettings.references = [currentPersonId];
                    this.selectedReferences = [currentPersonId];
                }
                this.selectedReferenceType = this.rosterSettings.referenceType;
                if (this.$stateParams.startDay) {
                    this.rosterSettings.dataFrom = moment(this.$stateParams.startDay).toDate();
                    this.rosterSettings.dataTo = moment(this.$stateParams.startDay).toDate();
                }
                this.validation = {
                    errors: [],
                    warnings: [],
                    isLoading: false
                };
                if (QMC.Common.Constants.IS_MOBILE) {
                    this.isMobile = true;
                    this.rosterSettings.showWorkingEventsInfo = true;
                }
                this.normalizeSchedulerSettings();
                let _this = this;
                this.events();
                this.init();
                // get Permissions
                this.loading.permission = true;
                permissionService.getPermissionsByObjectTypes([410000, 411001, 120031, 120030, 411003, 411005, 120024, 411004, 411006, 411008, 411007, 411015, 411016, 411017]).then((data) => {
                    this.permission.view = data[0].view && data[0].moduleAccess;
                    this.loading.permission = false;
                    if (!this.permission.view)
                        return;
                    this.servicePermission = $.grep(data, function (e) { return e.objectType === 411001; })[0];
                    //chek if the user has permission for documentating events / istzeit erfassen
                    this.permission.serviceDocumenteted.openFile = data[2].openFile;
                    this.permission.service = {
                        new: this.servicePermission.new,
                        modify: this.servicePermission.modify,
                        delete: this.servicePermission.delete
                    };
                    this.wtOverviewPermission = $.grep(data, function (e) { return e.objectType === 120030; })[0];
                    this.holidayPermissions.standard = $.grep(data, function (e) { return e.objectType === 411003; })[0];
                    this.holidayPermissions.special = $.grep(data, function (e) { return e.objectType === 411005; })[0];
                    this.holidayPermissions.approved = $.grep(data, function (e) { return e.objectType === 120024; })[0];
                    this.holidayPermissions.document = $.grep(data, function (e) { return e.objectType === 411016; })[0];
                    this.holidayPermissions.documentSpecial = $.grep(data, function (e) { return e.objectType === 411017; })[0];
                    this.sickLeavePermissions.standard = $.grep(data, function (e) { return e.objectType === 411003; })[0];
                    this.sickLeavePermissions.accident = $.grep(data, function (e) { return e.objectType === 411006; })[0];
                    this.sickLeavePermissions.document = $.grep(data, function (e) { return e.objectType === 411008; })[0];
                    this.exemptionPermissions = {
                        standard: $.grep(data, function (e) { return e.objectType === 411007; })[0],
                        approved: $.grep(data, function (e) { return e.objectType === 120024; })[0],
                        document: $.grep(data, function (e) { return e.objectType === 411015; })[0]
                    };
                    // load settings
                    this.userService.getUserSettings(['ROSTER.ASKDROPPEDSERVICE']).then((data) => {
                        this.askDroppedService = data[0].value === '' ? QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE : data[0].value.toLowerCase() === 'true';
                    });
                    //setup the calendar
                    this.setupCalendar();
                    // load data
                    this.getTemplates();
                    this.getInstitutes();
                    this.getEmployees();
                    this.getWvList();
                });
                this.resetCalendar();
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            ///// BEGIN Handler for selectNewServiceModal /////
            openNewServiceSelect() {
                var _a;
                if (!this.loading.allLoaded())
                    return;
                this.selectedNewReference = $('#session').data().personId;
                if (!this.employees.some(x => x.value === this.selectedNewReference))
                    this.selectedNewReference = (_a = this.employees[0]) === null || _a === void 0 ? void 0 : _a.value;
                $('#selectNewServiceModal').modal('show');
            }
            // Button click handler for a template item
            newServiceSelected(template) {
                const reference = this.employees.filter(x => x.value === this.selectedNewReference)[0];
                this.eventReference = {
                    id: reference.value,
                    instituteId: reference.instituteId,
                    name: reference.text
                };
                const wantedRosterType = { rosterTypeId: Roster.Constants.SERVICE, rosterSubTypeId: Roster.Constants.SUBTYPE_PLANNED };
                this.handleTemplateDrop(template, moment().startOf('day').toDate(), wantedRosterType);
            }
            // Button click handler if general "Soll-Dienst" was clicked
            newServiceSelectedGeneralPlanning() {
                const reference = this.employees.filter(x => x.value === this.selectedNewReference)[0];
                this.initNewForm();
                $('#new-service-modal').modal('show');
                this.serviceForm.referenceIds = [reference.value];
            }
            ///// END Handler for selectNewServiceModal /////
            // Handle drop of a template on a cell
            handleTemplateDrop(template, date, droppedOnRosterType) {
                if (template.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE) {
                    this.handleRosterDrop(template, date, droppedOnRosterType);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_HOLIDAY) {
                    this.handleHolidayDrop(template, date);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_DISEASE) {
                    this.handleDiseaseDrop(template, date);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_EXEMPTION) {
                    this.handleExemptionDrop(template, date);
                }
                else {
                    this.$qui.notify({
                        title: "Sorry",
                        message: "Not yet implemented",
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
                this.$qui.scopeApply(this.$scope);
            }
            // Handle a roster template drop
            handleRosterDrop(template, date, droppedOnRosterType) {
                var _a, _b;
                const wantedRosterType = (_a = droppedOnRosterType === null || droppedOnRosterType === void 0 ? void 0 : droppedOnRosterType.rosterTypeId) !== null && _a !== void 0 ? _a : Roster.Constants.SERVICE;
                const wantedSubType = (_b = droppedOnRosterType === null || droppedOnRosterType === void 0 ? void 0 : droppedOnRosterType.rosterSubTypeId) !== null && _b !== void 0 ? _b : Roster.Constants.SUBTYPE_PLANNED;
                const wantToCreateIsTime = wantedRosterType === Roster.Constants.SERVICE && wantedSubType === Roster.Constants.SUBTYPE_DOCUMENTED;
                const dateTo = this.calculateDateTo(date, template);
                this.validation.errors = [];
                this.validation.isLoading = false;
                const calendarInfo = {
                    date: date,
                    timeFrom: null,
                    timeTo: null,
                    referenceRessource: this.eventReference.id,
                    referenceInstituteId: template.instituteId
                };
                this.initNewForm(template, calendarInfo);
                this.serviceForm.dateFrom = date;
                this.serviceForm.dateTo = dateTo;
                // This will create an Is-Time
                if (wantToCreateIsTime) {
                    this.serviceForm.parentId = QMC.Common.Constants.GUID_EMPTY;
                }
                const mustOpenModal = this.askDroppedService || ((!wantToCreateIsTime) && this.isDateLockedForType(this.serviceForm.referenceIds, Roster.Constants.SUBTYPE_PLANNED, this.serviceForm.dateFrom, dateTo));
                if (mustOpenModal)
                    this.openNewServiceModal();
                else
                    this.saveNewService(this.serviceForm, false, wantToCreateIsTime);
            }
            handleHolidayDrop(template, date) {
                var _a, _b;
                if (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_HOLIDAY && this.holidayPermissions.standard.new || template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL && this.holidayPermissions.special.new) {
                    this.holidayCalls.new({
                        comment: "",
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        holidayTypeId: null,
                        isSpecialHoliday: template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL,
                        color: template.color,
                        amountOfDays: 1,
                        amountOfHours: 0,
                        accountingTypeFlag: 0,
                        isManualDays: true,
                        isManualHours: false,
                        creditWorkAsHoliday: false,
                        permissionApproved: (_a = this.holidayPermissions.approved) === null || _a === void 0 ? void 0 : _a.openFile,
                        approvedId: ((_b = this.holidayPermissions.approved) === null || _b === void 0 ? void 0 : _b.openFile) ? QMC.Common.Constants.APPROVAL_APRROVED_ID : QMC.Common.Constants.APPROVAL_PENDING_ID
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            }
            handleDiseaseDrop(template, date) {
                var _a, _b, _c, _e;
                if (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD && this.sickLeavePermissions.standard.new || template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT && this.sickLeavePermissions.accident.new) {
                    this.sickLeaveCalls.new({
                        id: null,
                        objectId: null,
                        comment: '',
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        color: template.color,
                        amountOfDays: 0,
                        amountOfHours: 0,
                        accountingTypeFlag: 0,
                        caption: template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT ? this.lng.translate(0, 'Arbeitsunfall') : this.lng.translate(0, 'Krankheit'),
                        captionShort: (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT ? this.lng.translate(0, 'Arbeitsunfall') : this.lng.translate(0, 'Krankheit')).substring(0, 1).toUpperCase(),
                        diseaseKindId: null,
                        referenceId: (_b = (_a = this.eventReference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                        instituteId: (_e = (_c = this.eventReference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _e !== void 0 ? _e : null,
                        serviceSubTypeId: template.serviceSubTypeId
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            }
            handleExemptionDrop(template, date) {
                var _a, _b, _c, _e, _f;
                if (this.exemptionPermissions.standard.new) {
                    this.exemptionCalls.new({
                        comment: '',
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        color: template.color,
                        caption: this.lng.translate(20028042, 'Freistellung'),
                        captionShort: this.lng.translate(20028042, 'Freistellung').substring(0, 1).toUpperCase(),
                        exemptionKindId: null,
                        referenceId: (_b = (_a = this.eventReference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                        instituteId: (_e = (_c = this.eventReference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _e !== void 0 ? _e : null,
                        serviceSubTypeId: template.serviceSubTypeId,
                        permissionApproved: (_f = this.exemptionPermissions.approved) === null || _f === void 0 ? void 0 : _f.openFile,
                        approvedId: QMC.Common.Constants.APPROVAL_PENDING_ID
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            }
            calculateDateTo(date, template) {
                //kill time component of drop date and create new moment
                const dropDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                const dropDateMoment = moment(dropDate);
                //get time component parts from dateFrom
                const momentTimeFrom = moment(template.timeFrom);
                const minutes = momentTimeFrom.minutes();
                const hours = momentTimeFrom.hours();
                //add hours and minutes to drop date
                const modDropDateMomentHours = dropDateMoment.clone().add(hours, 'hour');
                const modDropDateMomentMinutes = modDropDateMomentHours.clone().add(minutes, 'minute');
                //calculate timespan between the two dates in template
                const momentFrom = moment(template.timeFrom);
                const momentTo = moment(template.timeTo);
                const timespan = moment.duration(momentTo.diff(momentFrom));
                //add timespan to drop date and return dateTo
                return moment(modDropDateMomentMinutes).add(timespan).toDate();
            }
            openExistingService(id) {
                this.formState = 'edit';
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
                this.getService(id);
            }
            openExistingPlannedService(id) {
                $('#new-service-modal').modal('hide');
                $('#show-planning-modal').modal('show');
                this.getService(id);
            }
            openModifyModal() {
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
                this.formState = 'edit';
            }
            getTempaltesById(id) {
                if (this.templateList && this.templateList.filter(item => { return item.value === id; }).length > 0)
                    return this.templateList.filter(item => { return item.value === id; })[0].items;
                return null;
            }
            resetCalendar(keepData = false) {
                if (keepData)
                    this.keepData = true;
                $('#rosterCalendar').fullCalendar('destroy');
                this.setupCalendar(undefined);
                setTimeout(() => this.keepData = false, 25);
            }
            prepareForValidation(serviceForm, validationFormList, proposedConflictCheckAction = 0) {
                var _a, _b, _c;
                const breakFromDeviations = (_b = (_a = this.breakDeviationSummary) === null || _a === void 0 ? void 0 : _a.minutes) !== null && _b !== void 0 ? _b : 0;
                for (let referenceItem of serviceForm.referenceIds) {
                    const formToValidate = angular.copy(serviceForm);
                    formToValidate.dateFrom = this.$qui.addTimeToDate(serviceForm.dateFrom, serviceForm.timeFrom);
                    formToValidate.dateTo = this.$qui.addTimeToDate(serviceForm.dateTo, serviceForm.timeTo);
                    formToValidate.reference = this.employeesList.filter((x) => x.id === referenceItem)[0].displayTitle;
                    formToValidate.referenceId = referenceItem;
                    formToValidate.institute = (serviceForm.instituteId !== null && serviceForm.instituteId !== undefined && serviceForm.instituteId !== QMC.Common.Constants.GUID_EMPTY) ? this.institutes.filter((x) => x.value === serviceForm.instituteId)[0].text : QMC.Common.Constants.GUID_EMPTY;
                    formToValidate.conflictProposedAction = proposedConflictCheckAction;
                    formToValidate.break = ((_c = serviceForm.break) !== null && _c !== void 0 ? _c : 0) + breakFromDeviations;
                    validationFormList.push(formToValidate);
                }
            }
            validate(form = null) {
                if (!this.validationChanged())
                    return;
                this.validation.errors = [];
                this.validation.warnings = [];
                let listToCheck = [];
                this.prepareForValidation(form !== null && form !== void 0 ? form : this.serviceForm, listToCheck);
                this.lastValidation = JSON.stringify(listToCheck);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then((conflictsResult) => {
                    this.validation.errors = conflictsResult.errors;
                    this.validation.warnings = conflictsResult.warnings;
                    this.validation.isLoading = false;
                    this.showValidationBox = true;
                });
            }
            validationChanged(form = null) {
                if (!this.lastValidation)
                    return true;
                let listToCheck = [];
                this.prepareForValidation(form !== null && form !== void 0 ? form : this.serviceForm, listToCheck);
                listToCheck.forEach(x => delete x.conflictProposedAction);
                const oldV = JSON.parse(this.lastValidation);
                oldV.forEach(x => delete x.conflictProposedAction);
                return JSON.stringify(listToCheck) !== JSON.stringify(oldV);
            }
            saveNewService(form, ignoreWarnings = false, postAsIsTime = false) {
                this.validation.errors = [];
                this.validation.warnings = [];
                let listToCheck = [];
                this.prepareForValidation(form, listToCheck);
                this.lastValidation = JSON.stringify(listToCheck);
                //before saving check for conflicts
                form.dateFrom = this.$qui.addTimeToDate(form.dateFrom, form.timeFrom);
                form.dateTo = this.$qui.addTimeToDate(form.dateTo, form.timeTo);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then((conflictsResult) => {
                    if (conflictsResult.errors.length > 0 || (conflictsResult.warnings.length > 0 && !ignoreWarnings)) {
                        this.validation.errors = conflictsResult.errors;
                        this.validation.warnings = conflictsResult.warnings;
                        this.showValidationBox = true;
                    }
                    else {
                        if (!postAsIsTime)
                            this.postPlanningOrIsTime(form);
                        else
                            this.postIsTime(form);
                        $('#new-service-modal').modal('hide');
                    }
                }).finally(() => {
                    this.validation.isLoading = false;
                });
            }
            getAdditionalString(ids) {
                var _a;
                let result = "";
                for (let i = 0; i < ids.length; i++) {
                    result += (_a = $.grep(this.serviceAdditionals, function (e) { return e.value === ids[i]; })[0]) === null || _a === void 0 ? void 0 : _a.text;
                    if (i < ids.length - 1)
                        result += ", ";
                }
                return result;
            }
            createNewServiceFromPlanning() {
                this.serviceForm.parentId = this.serviceForm.objectId;
                this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                this.validation.errors = this.isLocked ? [this.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                this.serviceForm.id = null;
                this.serviceForm.objectId = null;
                this.pendingDeviations = [];
                this.breakDeviationSummary.minutes = 0;
                this.formState = 'new';
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
            }
            openNewServiceModal() {
                $('#new-service-modal').modal('show');
                this.resetServiceModalTab();
            }
            getTextColor(color) {
                const r = parseInt('0x' + color.substr(1, 2));
                const g = parseInt('0x' + color.substr(3, 2));
                const b = parseInt('0x' + color.substr(5, 2));
                const hsp = (r * 299 + g * 587 + b * 114) / 1000;
                // Using the HSP value, determine whether the color is light or dark
                if (hsp > 123) {
                    //light color, return black
                    return '#000000';
                }
                else {
                    //dark color return white
                    return '#FFFFFF';
                }
            }
            isDateLockedForType(referenceIds, type, dateFrom, dateTo) {
                if (!referenceIds || !this.locks)
                    return false;
                for (const referenceId of referenceIds) {
                    const referenceLocks = this.locks.filter(item => { return item.id === referenceId; });
                    if (referenceLocks.length === 0)
                        return false;
                    const actualLocks = referenceLocks[0].locks.filter(item => { return item.subTypeId === type; });
                    for (const actualLock of actualLocks) {
                        const lockRange = moment.range(moment(actualLock.dateFrom).startOf('day'), moment(actualLock.dateTo).endOf('day'));
                        const eventRange = moment.range(dateFrom, moment(dateTo).endOf('day'));
                        if (lockRange.overlaps(eventRange))
                            return true;
                    }
                }
                return false;
            }
            showLocks(id) {
                this.selectedPerson = this.rosterData.filter(item => item.id === id)[0] ? { name: this.rosterData.filter(item => item.id === id)[0].caption, locks: this.rosterData.filter(item => item.id === id)[0].locks } : { name: '', locks: [] };
                for (const lock of this.selectedPerson.locks) {
                    lock.lockedTypeNames = [];
                    if (lock.subTypeId === Roster.Constants.SUBTYPE_PLANNED)
                        lock.lockedTypeNames.push(this.lng.translate(20028004, 'Soll-Dienst'));
                    if (lock.subTypeId === Roster.Constants.SUBTYPE_DOCUMENTED)
                        lock.lockedTypeNames.push(this.lng.translate(20028003, 'Ist-Dienst'));
                }
                $('#show-lock-modal').modal('show');
            }
            showTemplates() {
                $('#templateDiv').show();
            }
            hideTemplates() {
                if (!this.isDragging) {
                    $('#templateDiv').hide();
                    this.$compile(angular.element($('.lockBtn')).contents())(this.$scope);
                }
            }
            showSettings() {
                $('#settingDiv').show();
            }
            hideSettings() {
                $('#settingDiv').hide();
            }
            showInfos() {
                this.setupCalendar(true);
                $('#rosterCalendarRessourcesDialog').modal('show');
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            getTemplates() {
                this.loading.template = true;
                this.rosterService.getTemplates().then((data) => {
                    this.templateList = [];
                    //remove not supported misc. templates
                    data = data.filter(x => x.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE || this.supportMiscTemplates.some(y => y === x.serviceTypeId));
                    // sort list elements by their institute
                    for (const element of data) {
                        const template = element;
                        if (!this.permission.service.new && template.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE)
                            continue;
                        const instituteContainer = this.templateList.filter(item => { return item.value === template.instituteId; })[0];
                        if (instituteContainer)
                            instituteContainer.items.push(template);
                        else
                            this.templateList.push({
                                text: template.institute,
                                value: template.instituteId,
                                items: [template]
                            });
                    }
                    if (this.templateList.length > 0)
                        this.selectedTemplateContainer = this.templateList[0].value;
                    if (this.templateList.filter(x => x.value === Roster.Constants.MISCELLANIOUS_TEMPLATE))
                        this.selectedTemplateContainer = Roster.Constants.MISCELLANIOUS_TEMPLATE;
                    this.loading.template = false;
                    this.setupDndEvents();
                });
            }
            getInstitutes() {
                this.loading.institute = true;
                this.rosterService.getInstituteList(null, true).then((data) => {
                    this.institutes = data.map(x => ({ value: x.objectId, text: x.caption }));
                    this.loading.institute = false;
                });
            }
            getEmployees() {
                this.loading.employee = true;
                this.clientService.getEmployeeList("", this.rosterSettings.showOnlyActiveReferences ? QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID : QMC.Common.Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID).then((data) => {
                    var _a;
                    this.employeesList = data;
                    this.employees = data.map((x) => ({ value: x.id, text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute, instituteId: x.instituteId }));
                    this.employees.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                    this.employees.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                    this.loading.employee = false;
                    this.selectedNewReference = $('#session').data().personId;
                    if (!this.employees.some(x => x.value === this.selectedNewReference))
                        this.selectedNewReference = (_a = this.employees[0]) === null || _a === void 0 ? void 0 : _a.value;
                });
            }
            getWvList() {
                this.loading.wv = true;
                this.rosterService.getRosterWv().then((data) => {
                    var _a;
                    this.serviceAdditionals = data.additionalWvList.map(x => ({ value: x.objectId, text: x.name }));
                    const subTypeList = (_a = data.serviceSubTypeWvList) !== null && _a !== void 0 ? _a : [];
                    const deviationSubTypes = subTypeList.filter(x => x.parentWvId === Roster.Constants.SUBTYPE_DEVIATION);
                    this.serviceSubTypes = (deviationSubTypes.length > 0 ? deviationSubTypes : subTypeList)
                        .map(x => ({ value: x.objectId, text: x.name }));
                    this.serviceSubTypes.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: '' });
                    this.predefinedViews = data.predefinedSearchesWvList.map(x => ({ value: x.objectId, text: x.name }));
                    this.selectedPredefinedView = this.resolvePredefinedView();
                    this.rosterSettings.predefinedView = this.selectedPredefinedView;
                    this.getReferenceTypes();
                    this.loading.wv = false;
                });
            }
            resolvePredefinedView() {
                var _a;
                const storedPredefinedView = this.rosterSettings.predefinedView;
                if (storedPredefinedView && storedPredefinedView !== QMC.Common.Constants.GUID_EMPTY
                    && this.predefinedViews.some(x => x.value === storedPredefinedView))
                    return storedPredefinedView;
                return (_a = this.predefinedViews[0]) === null || _a === void 0 ? void 0 : _a.value;
            }
            getReferenceTypes() {
                this.loading.referenceTypes = true;
                this.referenceTypes = [
                    { value: 120000, text: this.lng.translate(20000235, "Mitarbeiter") },
                    { value: 130000, text: this.lng.translate(20000236, "Einrichtung") },
                    { value: 190000, text: this.lng.translate(20000237, "Personenliste") },
                ];
                this.selectedReferenceType = this.rosterSettings.referenceType;
                this.selectedReferenceTypeName = this.referenceTypes.filter((x) => x.value === this.selectedReferenceType)[0].text;
                this.loading.referenceTypes = false;
                this.getReferences(this.selectedReferenceType);
            }
            getDefaultEmployeeReferenceId(employees) {
                var _a, _b;
                const currentPersonId = $('#session').data().personId;
                if (employees.some(item => item.id === currentPersonId))
                    return currentPersonId;
                const storedReferenceId = (_a = this.rosterSettings.references) === null || _a === void 0 ? void 0 : _a[0];
                if (storedReferenceId && employees.some(item => item.id === storedReferenceId))
                    return storedReferenceId;
                return (_b = employees[0]) === null || _b === void 0 ? void 0 : _b.id;
            }
            getReferences(referenceType = this.selectedReferenceType, reloadCalendar = true) {
                if (referenceType == null)
                    return;
                const requestKey = this.buildReferencesRequestKey(referenceType);
                if (requestKey === this.requestCache.references.pendingKey)
                    return;
                if (requestKey === this.requestCache.references.lastKey && this.requestCache.references.requestType === referenceType && this.references.length > 0) {
                    if (reloadCalendar)
                        this.getRosterData(false);
                    return;
                }
                this.requestCache.references.pendingKey = requestKey;
                this.requestCache.references.requestType = referenceType;
                this.loading.references = true;
                this.references = [];
                if (referenceType === 120000) {
                    this.clientService.getEmployeeList("", this.rosterSettings.showOnlyActiveReferences ? QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID : QMC.Common.Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID).then((data) => {
                        var _a;
                        if (this.requestCache.references.requestType !== referenceType)
                            return;
                        const employeeIds = data.map(item => item.id);
                        if (this.selectedReferences.length === 0 || this.selectedReferences.some(id => !employeeIds.includes(id)))
                            this.selectedReferences = [this.getDefaultEmployeeReferenceId(data)];
                        const referencesMapped = data.map((x) => ({ value: x.id, text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute }));
                        referencesMapped.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                        referencesMapped.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                        this.references = referencesMapped;
                        this.selectedReferenceName = (_a = referencesMapped.filter((x) => x.value === this.selectedReferences[0])[0]) === null || _a === void 0 ? void 0 : _a.text;
                        this.updateReferenceCreatePermission(this.selectedReferences[0]);
                        this.getRosterData(reloadCalendar);
                        this.finishReferencesRequest(requestKey);
                    }).catch(() => {
                        this.finishReferencesRequest(requestKey, false);
                    });
                }
                else {
                    this.rosterService.getReferences(referenceType).then((data) => {
                        if (this.requestCache.references.requestType !== referenceType)
                            return;
                        const referencesMapped = data.map(x => ({ value: x.id, text: x.name }));
                        if (!this.selectedReference || !referencesMapped.some(x => x.value === this.selectedReference))
                            this.selectedReference = referencesMapped[0].value;
                        this.references = referencesMapped;
                        this.selectedReferenceName = referencesMapped.filter((x) => x.value === this.selectedReference)[0].text;
                        this.getRosterData(true);
                        this.finishReferencesRequest(requestKey);
                    }).catch(() => {
                        this.finishReferencesRequest(requestKey, false);
                    });
                }
                ;
            }
            buildReferencesRequestKey(referenceType) {
                return JSON.stringify({
                    referenceType,
                    showOnlyActiveReferences: this.rosterSettings.showOnlyActiveReferences
                });
            }
            buildRosterDataRequestKey(references, referenceType, dateFrom, dateTo) {
                return JSON.stringify({
                    references: [...references].sort(),
                    referenceType,
                    dateFrom: moment(dateFrom).format('YYYY-MM-DD'),
                    dateTo: moment(dateTo).format('YYYY-MM-DD'),
                    selectedPredefinedView: this.selectedPredefinedView,
                    includeSub: this.rosterSettings.includeSub,
                    showWorkingEventsInfo: this.rosterSettings.showWorkingEventsInfo
                });
            }
            invalidateRosterDataCache() {
                this.requestCache.rosterData.lastKey = undefined;
            }
            finishReferencesRequest(requestKey, succeeded = true) {
                if (this.requestCache.references.pendingKey !== requestKey)
                    return;
                if (succeeded)
                    this.requestCache.references.lastKey = requestKey;
                this.requestCache.references.pendingKey = undefined;
                this.loading.references = false;
            }
            updateReferenceCreatePermission(referenceId) {
                if (!referenceId || referenceId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                const requestKey = `${referenceId}:411001`;
                if (requestKey === this.requestCache.referencePermission.pendingKey
                    || requestKey === this.requestCache.referencePermission.lastKey)
                    return;
                this.requestCache.referencePermission.pendingKey = requestKey;
                this.permissionService.getPermissionsForGivenUserAndObjectType(referenceId, 411001).then((data) => {
                    this.permission.service.new = data && this.servicePermission.new;
                    this.requestCache.referencePermission.lastKey = requestKey;
                }).finally(() => {
                    if (this.requestCache.referencePermission.pendingKey === requestKey)
                        this.requestCache.referencePermission.pendingKey = undefined;
                });
            }
            getRosterData(forceReload) {
                if (!this.calendarCreated &&
                    this.rosterSettings.dataFrom.getDate() != moment(this.rosterSettings.viewDate).toDate().getDate() ||
                    moment(this.rosterSettings.dataFrom).toDate().valueOf() === moment(this.rosterSettings.dataTo).toDate().valueOf()) {
                    this.resetCalendar();
                    this.calendarCreated = true;
                    //force the load of the data after the calender is created
                    setTimeout(() => {
                        this.getRosterData(false);
                    }, 250);
                }
                else {
                    let referencesIds = [];
                    if (this.selectedReferenceType === 120000) {
                        referencesIds = this.selectedReferences;
                    }
                    else {
                        referencesIds = [this.selectedReference];
                    }
                    const dateFrom = this.rosterSettings.dataFrom;
                    const dateTo = this.rosterSettings.dataTo;
                    this.$state.go('Roster', {
                        startDay: moment(this.rosterSettings.dataFrom).format('YYYY-MM-DD')
                    });
                    if (referencesIds.length) {
                        const requestId = this.$qui.generateGuid();
                        const referenceType = this.selectedReferenceType;
                        const references = this.selectedReferenceType === 120000 ? this.selectedReferences : [this.selectedReference];
                        const requestKey = this.buildRosterDataRequestKey(references, referenceType, dateFrom, dateTo);
                        if (requestKey === this.requestCache.rosterData.pendingKey && !forceReload)
                            return;
                        if (!forceReload && requestKey === this.requestCache.rosterData.lastKey)
                            return;
                        this.requestCache.rosterData.pendingKey = requestKey;
                        this.requestCache.rosterData.lastRequestId = requestId;
                        this.rosterSettings.references = this.selectedReferences;
                        this.rosterSettings.predefinedView = this.selectedPredefinedView;
                        this.loading.calendar = true;
                        this.rosterEvents = [];
                        this.rosterData = [];
                        this.rosterResources = [];
                        this.rosterService.getRosterData(referencesIds, referenceType, dateFrom, dateTo, this.selectedPredefinedView, this.rosterSettings.includeSub, this.rosterSettings.showWorkingEventsInfo).then((rosterResultData) => {
                            if (this.requestCache.rosterData.lastRequestId !== requestId)
                                return;
                            this.requestCache.rosterData.lastKey = requestKey;
                            if (this.requestCache.rosterData.pendingKey === requestKey)
                                this.requestCache.rosterData.pendingKey = undefined;
                            this.locks = [];
                            rosterResultData.forEach((reference) => {
                                if (this.rosterData.length === 0 || this.selectedReferenceType !== 120000 || forceReload) {
                                    this.rosterData = reference.data;
                                }
                                else {
                                    this.rosterData.push(reference.data[0]);
                                }
                                for (const element of this.rosterData) {
                                    const item = element;
                                    for (const element of item.services) {
                                        const service = element;
                                        let serviceTypeCaption = '';
                                        let addEvent = true;
                                        if (service.serviceTypeId === QMC.Common.Constants.GUID_EMPTY || service.serviceTypeId === null) {
                                            addEvent = !this.isMobile || this.selectedPredefinedView === '07eb5dfd-7c50-4d43-98ba-491f9d6839b2'; //07eb5dfd-7c50-4d43-98ba-491f9d6839b2 -> summary View
                                            serviceTypeCaption = (this.isMobile && (this.selectedReferenceType === 130000 || this.selectedReferenceType === 190000)) /*Organisation, Person Lists*/ ? item.caption + ': ' + service.caption : service.caption;
                                        }
                                        else {
                                            serviceTypeCaption = service.caption + ` (${service.captionSub})`;
                                        }
                                        this.rosterResources.push({
                                            id: service.id,
                                            referenceId: item.id,
                                            referenceInstituteId: item.instituteId,
                                            caption: item.caption,
                                            serviceType: serviceTypeCaption,
                                            serviceTypeId: service.serviceTypeId,
                                            currentValue: service.currentValue,
                                            plannedValue: service.plannedValue,
                                            targetValue: service.targetValue,
                                            totalValue: service.totalValue,
                                            restHolidaysValue: service.restHolidaysValue
                                        });
                                        for (const element of service.items) {
                                            const serviceItem = element;
                                            //07eb5dfd-7c50-4d43-98ba-491f9d6839b2 -> summary View
                                            if (addEvent) {
                                                this.rosterEvents.push({
                                                    id: serviceItem.id,
                                                    objectId: serviceItem.objectId,
                                                    referenceId: item.id,
                                                    resourceId: service.id,
                                                    serviceTypeId: serviceItem.serviceTypeId,
                                                    serviceSubTypeId: serviceItem.serviceSubTypeId,
                                                    title: this.isMobile ?
                                                        serviceItem.captionShort + ' (' + serviceTypeCaption + ') ' + '-' + ' (' + item.caption + ')' :
                                                        serviceItem.captionShort,
                                                    start: serviceItem.dateFrom,
                                                    end: serviceItem.dateTo,
                                                    color: serviceItem.color,
                                                    captionEventType: serviceItem.captionEventType,
                                                    editable: false,
                                                    fullTitle: serviceItem.caption,
                                                    textColor: this.getTextColor(serviceItem.color)
                                                });
                                            }
                                        }
                                        for (const element of item.locks) {
                                            this.locks.push({ id: item.id, locks: item.locks });
                                            for (const lock of item.locks)
                                                this.rosterEvents.push({
                                                    title: '',
                                                    fullTitle: lock.lockDescription,
                                                    start: lock.dateFrom,
                                                    end: lock.dateTo,
                                                    rendering: 'background',
                                                    resourceId: service.id,
                                                    editable: false,
                                                    noPopover: false
                                                });
                                        }
                                    }
                                }
                            });
                            const viewDate = this.rosterSettings.viewDate;
                            if (!this.calendarCreated) {
                                this.resetCalendar();
                                this.calendarCreated = true;
                            }
                            else {
                                $('#rosterCalendar').fullCalendar('option', 'resources', this.rosterResources);
                                $('#rosterCalendar').fullCalendar('refetchResources');
                                $('#rosterCalendar').fullCalendar('removeEvents');
                                $('#rosterCalendar').fullCalendar('addEventSource', this.rosterEvents);
                                // change also for mobile ressource view
                                if (this.resourceViewMobileCreated) {
                                    $('#rosterCalendarRessources').fullCalendar('option', 'resources', this.rosterResources);
                                    $('#rosterCalendarRessources').fullCalendar('refetchResources');
                                    $('#rosterCalendarRessources').fullCalendar('removeEvents');
                                    $('#rosterCalendarRessources').fullCalendar('addEventSource', this.rosterEvents);
                                }
                            }
                            $('#rosterCalendar').fullCalendar('gotoDate', viewDate);
                            if (this.resourceViewMobileCreated) {
                                $('#rosterCalendarRessources').fullCalendar('gotoDate', viewDate);
                            }
                            this.loading.calendar = false;
                        }).catch(() => {
                            if (this.requestCache.rosterData.lastRequestId !== requestId)
                                return;
                            if (this.requestCache.rosterData.pendingKey === requestKey)
                                this.requestCache.rosterData.pendingKey = undefined;
                            this.loading.calendar = false;
                        });
                    }
                }
            }
            // Posts an Is or Planned Time
            postPlanningOrIsTime(form = this.serviceForm) {
                this.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                this.loading.calendar = true;
                this.invalidateRosterDataCache();
                // When form.parentId is given, it will be an Is-Time. Else a planned time.
                if (!form.parentId || form.parentId === QMC.Common.Constants.GUID_EMPTY) {
                    this.postPlannedTime(form);
                }
                else if (!form.objectId || form.objectId === QMC.Common.Constants.GUID_EMPTY) {
                    this.postIsTime(form);
                }
            }
            // Posts a planned time
            postPlannedTime(form) {
                if (!form.referenceIds || !form.referenceIds.length)
                    form.referenceIds = [form.referenceId];
                this.rosterService.postServicePlanning(form).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    this.getRosterData(true);
                    this.lastValidation = undefined;
                    this.validation.errors = [];
                    this.validation.warnings = [];
                });
            }
            // Posts an Is-Time
            postIsTime(form) {
                this.rosterService.postServiceDocu(form.parentId, form).then((result) => {
                    const createdId = result === null || result === void 0 ? void 0 : result.createdId;
                    const pendingPayload = this.mapPendingDeviationsToCreate();
                    const finish = () => {
                        this.pendingDeviations = [];
                        this.$qui.notify(this.$qui.successNote);
                        this.getRosterData(true);
                        this.lastValidation = undefined;
                        this.validation.errors = [];
                        this.validation.warnings = [];
                    };
                    if (createdId && pendingPayload.length > 0) {
                        this.rosterService.postDeviationsMultiple(createdId, pendingPayload).then(finish);
                    }
                    else {
                        finish();
                    }
                });
            }
            mapPendingDeviationsToCreate() {
                var _a;
                return ((_a = this.pendingDeviations) !== null && _a !== void 0 ? _a : []).map((deviation) => {
                    var _a, _b, _c;
                    return ({
                        dateFrom: this.$qui.createDateFromString(deviation.dateFrom),
                        dateTo: this.$qui.createDateFromString(deviation.dateTo),
                        caption: deviation.caption,
                        captionShort: deviation.captionShort,
                        color: deviation.color,
                        comment: (_a = deviation.comment) !== null && _a !== void 0 ? _a : '',
                        instituteId: deviation.instituteId,
                        break: (_b = deviation.break) !== null && _b !== void 0 ? _b : 0,
                        typeId: deviation.typeId,
                        additionalWvIds: (_c = deviation.additionalWvIds) !== null && _c !== void 0 ? _c : []
                    });
                });
            }
            resetServiceModalTab() {
                setTimeout(() => { $('#serviceDataTabButton').click(); }, 50);
            }
            putService(form = this.serviceForm, ignoreWarnings = false) {
                this.validation.errors = [];
                this.validation.warnings = [];
                let listToCheck = [];
                this.prepareForValidation(form, listToCheck, 1);
                this.lastValidation = JSON.stringify(listToCheck);
                this.validation.isLoading = true;
                form.dateFrom = this.$qui.addTimeToDate(form.dateFrom, form.timeFrom);
                form.dateTo = this.$qui.addTimeToDate(form.dateTo, form.timeTo);
                form.referenceId = form.referenceIds[0];
                this.rosterService.checkForConflictErrors(listToCheck).then((conflictsResult) => {
                    if (conflictsResult.errors.length > 0 || (conflictsResult.warnings.length > 0 && !ignoreWarnings)) {
                        this.validation.errors = conflictsResult.errors;
                        this.validation.warnings = conflictsResult.warnings;
                        this.showValidationBox = true;
                    }
                    else {
                        this.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                        this.loading.calendar = true;
                        this.invalidateRosterDataCache();
                        this.rosterService.putService(form.objectId, form).then(() => {
                            this.$qui.notify(this.$qui.successNote);
                        }).finally(() => {
                            this.getRosterData(true);
                            this.lastValidation = undefined;
                            this.validation.errors = [];
                            this.validation.warnings = [];
                        });
                        $('#new-service-modal').modal('hide');
                    }
                }).finally(() => {
                    this.validation.isLoading = false;
                });
                ;
            }
            deleteService(form = this.serviceForm) {
                this.validation.errors = [];
                //before saving check for conflicts
                let listToCheck = [];
                this.prepareForValidation(form, listToCheck, 2);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then((conflictsResult) => {
                    if (conflictsResult.errors.length > 0) {
                        this.validation.errors = conflictsResult.errors;
                        this.validation.isLoading = false;
                        this.showValidationBox = true;
                    }
                    else {
                        this.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                        this.loading.calendar = true;
                        this.invalidateRosterDataCache();
                        this.rosterService.deleteService(form.objectId).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.getRosterData(true);
                        });
                        this.validation.isLoading = false;
                        $('#new-service-modal').modal('hide');
                    }
                });
            }
            getService(id, event = null) {
                //event - use this for when dragging and dropping an event
                this.loading.detail = true;
                if (event === null || event === void 0 ? void 0 : event.start) { // open detail modal right away when detail is modified
                    $('#new-service-modal').modal('show');
                }
                this.rosterService.getService(id).then((dataService) => {
                    this.serviceForm = dataService;
                    this.pendingDeviations = [];
                    this.breakDeviationSummary.minutes = 0;
                    this.serviceForm.dateFrom = this.$qui.createDateFromString(dataService.dateFrom);
                    this.serviceForm.dateTo = this.$qui.createDateFromString(dataService.dateTo);
                    this.serviceForm.timeFrom = this.$qui.createDateFromString(dataService.dateFrom);
                    this.serviceForm.timeTo = this.$qui.createDateFromString(dataService.dateTo);
                    this.serviceForm.referenceIds = [dataService.referenceId];
                    this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                    this.validation.errors = this.isLocked ? [this.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    this.$qui.scopeApply(this.$scope);
                    this.permissionService.getPermissionsForDataset(id, 411001).then((dataPerm) => {
                        var _a, _b;
                        this.permission.service = {
                            delete: dataPerm[0].delete,
                            modify: dataPerm[0].modify,
                            new: this.servicePermission.new
                        };
                        if (event === null || event === void 0 ? void 0 : event.start) {
                            let dateTo = event.end;
                            if (!dateTo) {
                                dateTo = event.start;
                                const diff = moment.duration(moment(this.serviceForm.timeTo).diff(moment(this.serviceForm.timeFrom))).asHours();
                                dateTo.add(diff, 'hours');
                            }
                            this.serviceForm.dateFrom = event.start.toDate();
                            this.serviceForm.dateTo = dateTo.toDate();
                            this.serviceForm.timeFrom = moment(event.start).toDate();
                            this.serviceForm.timeTo = dateTo.toDate();
                        }
                        if (event === null || event === void 0 ? void 0 : event.resourceId) {
                            this.serviceForm.referenceIds = [(_b = (_a = this.rosterResources.filter(x => x.id === event.resourceId)[0]) === null || _a === void 0 ? void 0 : _a.referenceId) !== null && _b !== void 0 ? _b : dataService.referenceId];
                        }
                        this.loading.detail = false;
                        document.getElementById('serviceModalBody').scrollTop = 0;
                    });
                });
            }
            ///////////////////////////// SETUP //////////////////////////////
            init() {
                this.$qui.waitForEl('#newModalButton', () => {
                    $('#newModalButton').click(() => {
                        this.initNewForm();
                        setTimeout(() => {
                            document.getElementById('serviceModalBody').scrollTop = 0;
                        }, 250);
                    });
                });
                this.initNewForm();
            }
            initNewForm(template = null, calendarInfo = null) {
                var _a, _b;
                this.validation.errors = [];
                this.validation.warnings = [];
                this.lastValidation = undefined;
                this.validation.isLoading = false;
                this.showValidationBox = false;
                this.pendingDeviations = [];
                this.breakDeviationSummary.minutes = 0;
                let reference = calendarInfo !== null ? calendarInfo.referenceRessource : $('#session').data().personId;
                if (this.employees.length === 0) {
                    this.getEmployees();
                }
                let instituteId = calendarInfo !== null ? calendarInfo.referenceInstituteId : null;
                if (this.employeesList.length > 0) {
                    instituteId = this.employeesList.filter((x) => x.id === reference)[0].instituteId;
                }
                this.serviceForm = {
                    id: null,
                    objectId: null,
                    additionalWvIds: (_a = template === null || template === void 0 ? void 0 : template.additionalWvIds) !== null && _a !== void 0 ? _a : [],
                    break: template !== null ? template.break : 0,
                    caption: template !== null ? template.caption : "",
                    captionShort: template !== null ? template.captionShort : "",
                    color: template !== null ? template.color : "#FF0000",
                    dateFrom: calendarInfo !== null ? calendarInfo.date : new Date(),
                    dateTo: calendarInfo !== null ? calendarInfo.date : new Date(),
                    instituteId: ((_b = this.institutes) === null || _b === void 0 ? void 0 : _b.length) > 0 ? calendarInfo !== null ? calendarInfo.referenceInstituteId : instituteId : null,
                    institute: null,
                    referenceIds: [reference],
                    referenceId: reference,
                    reference: null,
                    templateId: template !== null ? template.objectId : null,
                    timeFrom: template !== null ? this.$qui.createDateFromString(template.timeFrom) : moment().minutes(0).toDate(),
                    timeTo: template !== null ? this.$qui.createDateFromString(template.timeTo) : moment().minutes(0).toDate(),
                    comment: "",
                    conflictProposedAction: 0
                };
                if (calendarInfo !== null && (!template || (template === null || template === void 0 ? void 0 : template.serviceSubTypeId))) {
                    this.serviceForm.timeFrom.setHours(calendarInfo.timeFrom !== null ? calendarInfo.timeFrom.getHours() : this.serviceForm.timeFrom.getHours() - 1);
                    this.serviceForm.timeTo.setHours(calendarInfo.timeFrom !== null ? calendarInfo.timeTo.getHours() + 1 : this.serviceForm.timeTo.getHours());
                }
                this.$qui.scopeApply(this.$scope);
                this.formState = 'new';
            }
            events() {
                this.$scope.$watch('vm.selectedTemplateContainer', () => {
                    this.setupDndEvents();
                });
                this.$scope.$watch('vm.selectedReferenceType', (newVal, oldVal) => {
                    var _a, _b;
                    if (newVal !== oldVal && newVal != null && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                        this.selectedReferenceTypeName = (_b = (_a = this.referenceTypes.filter((x) => x.value === this.selectedReferenceType)[0]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
                        if (oldVal != null && oldVal !== QMC.Common.Constants.GUID_EMPTY) {
                            this.selectedReferences = [];
                            this.selectedReference = QMC.Common.Constants.GUID_EMPTY;
                            this.requestCache.referencePermission.lastKey = undefined;
                        }
                        this.rosterSettings.referenceType = this.selectedReferenceType;
                        this.getReferences(this.selectedReferenceType);
                    }
                });
                this.$scope.$watch('vm.selectedReference', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal != null && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                        if (this.selectedReferenceType !== 120000)
                            this.updateReferenceCreatePermission(this.selectedReference);
                        this.selectedReferences = [this.selectedReference];
                        this.getRosterData(true);
                        this.rosterSettings.references = [this.selectedReference];
                        this.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.selectedReferences', (newVal, oldVal) => {
                    if ((newVal !== oldVal && newVal !== (null || undefined)) && (newVal.length < oldVal.length)) {
                        this.calendarNoReload = true;
                        //remove ressources that are not anymore present in the references list
                        for (let i = 0; i < this.rosterResources.length; i++) {
                            const resourceItem = this.rosterResources[i];
                            const roosterReference = this.selectedReferences.filter((x) => x === resourceItem.referenceId);
                            if (roosterReference === null || roosterReference.length === 0) {
                                $('#rosterCalendar').fullCalendar('removeResource', resourceItem.referenceId);
                                this.rosterResources.splice(i);
                            }
                        }
                        $('#rosterCalendar').fullCalendar('option', 'resources', this.rosterResources);
                        $('#rosterCalendar').fullCalendar('refetchResources');
                        $('#rosterCalendar').fullCalendar('removeEvents');
                        $('#rosterCalendar').fullCalendar('addEventSource', this.rosterEvents);
                        // change also for mobile ressource view
                        if (this.resourceViewMobileCreated) {
                            $('#rosterCalendarRessources').fullCalendar('option', 'resources', this.rosterResources);
                            $('#rosterCalendarRessources').fullCalendar('refetchResources');
                            $('#rosterCalendarRessources').fullCalendar('removeEvents');
                            $('#rosterCalendarRessources').fullCalendar('addEventSource', this.rosterEvents);
                        }
                    }
                    else if (newVal !== oldVal && newVal !== (null || undefined)) {
                        this.calendarNoReload = false;
                        //call the server methods for filling the roster data only for the last inserted item
                        this.getRosterData(true);
                    }
                    this.rosterSettings.references = this.selectedReferences;
                    this.scrollPosition = 0;
                });
                this.$scope.$watch('vm.rosterSettings.includeSub', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        this.getRosterData(true);
                        this.rosterSettings.references = [this.selectedReference];
                        this.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.rosterSettings.showOnlyActiveReferences', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal !== (null || undefined)) {
                        this.getReferences(this.selectedReferenceType, false);
                    }
                });
                this.$scope.$watch('vm.selectedPredefinedView', (newVal, oldVal) => {
                    if (this.selectedReferences.length === 0 && this.selectedReference !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        this.selectedReferences = [this.selectedReference];
                    }
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY) && (this.selectedReferences.length > 0 || this.selectedReference !== (null || undefined || QMC.Common.Constants.GUID_EMPTY))) {
                        this.getRosterData(true);
                        this.rosterSettings.predefinedView = this.selectedPredefinedView;
                        this.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.rosterSettings', () => {
                    if (!this.debounceCheck) {
                        this.debounceCheck = true;
                        this.persistRosterSettings();
                        console.log("rosterSettings have been changed...", this.rosterSettings);
                        setTimeout(() => {
                            this.debounceCheck = false;
                        }, 250);
                    }
                }, true);
                this.$scope.$watch('vm.serviceForm.dateFrom', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    if (this.serviceForm.dateTo < this.serviceForm.dateFrom)
                        this.serviceForm.dateTo = this.serviceForm.dateFrom;
                    this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                    this.validation.errors = this.isLocked ? [this.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    this.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.dateTo', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    if (this.serviceForm.dateTo < this.serviceForm.dateFrom)
                        this.serviceForm.dateFrom = this.serviceForm.dateTo;
                    this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                    this.validation.errors = this.isLocked ? [this.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    this.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.timeFrom', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    const from = this.$qui.addTimeToDate(this.serviceForm.dateFrom, this.serviceForm.timeFrom);
                    const to = this.$qui.addTimeToDate(this.serviceForm.dateTo, this.serviceForm.timeTo);
                    if (to < from)
                        this.serviceForm.timeTo = this.serviceForm.timeFrom;
                    this.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.timeTo', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    const from = this.$qui.addTimeToDate(this.serviceForm.dateFrom, this.serviceForm.timeFrom);
                    const to = this.$qui.addTimeToDate(this.serviceForm.dateTo, this.serviceForm.timeTo);
                    if (to < from)
                        this.serviceForm.timeFrom = this.serviceForm.timeTo;
                    this.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.referenceIds', (newVal, oldVal) => {
                    if (newVal === oldVal || newVal.length === 0)
                        return;
                    this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                });
                this.$scope.$watch('vm.rosterSettings.showWeekends', (newVal, oldVal) => {
                    if (newVal !== oldVal && !this.debounceCheckShowWeekends) {
                        this.debounceCheckShowWeekends = true;
                        setTimeout(() => {
                            this.resetCalendar(true);
                            this.debounceCheckShowWeekends = false;
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.rosterSettings.highlightWeekends', (newVal, oldVal) => {
                    if (newVal !== oldVal && !this.debounceCheckHighlightWeekends) {
                        this.debounceCheckHighlightWeekends = true;
                        setTimeout(() => {
                            this.resetCalendar(true);
                            this.debounceCheckHighlightWeekends = false;
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.rosterSettings.showWorkingEventsInfo', (newVal, oldVal) => {
                    if (newVal !== oldVal && !this.debounceCheckShowWorkingEventsInfo) {
                        this.debounceCheckShowWorkingEventsInfo = true;
                        setTimeout(() => {
                            this.resetCalendar(true);
                            $('#rosterCalendar').fullCalendar('option', 'resources', this.rosterResources);
                            $('#rosterCalendar').fullCalendar('refetchResources');
                            $('#rosterCalendar').fullCalendar('removeEvents');
                            $('#rosterCalendar').fullCalendar('addEventSource', this.rosterEvents);
                            // change also for mobile ressource view
                            if (this.resourceViewMobileCreated) {
                                $('#rosterCalendarRessources').fullCalendar('option', 'resources', this.rosterResources);
                                $('#rosterCalendarRessources').fullCalendar('refetchResources');
                                $('#rosterCalendarRessources').fullCalendar('removeEvents');
                                $('#rosterCalendarRessources').fullCalendar('addEventSource', this.rosterEvents);
                            }
                            this.debounceCheckShowWorkingEventsInfo = false;
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.rosterSettings.schedulerViewType', (newVal, oldVal) => {
                    if (newVal !== oldVal && !this.debounceCheckSchedulerViewType) {
                        this.debounceCheckSchedulerViewType = true;
                        setTimeout(() => {
                            this.resetCalendar(true);
                            this.debounceCheckSchedulerViewType = false;
                        }, 250);
                    }
                });
            }
            setupDndEvents() {
                const vm = this;
                setTimeout(() => {
                    $('.fc-event.dummy').each(function () {
                        $(this).data('event', {
                            stick: true,
                            id: $(this).data('id'),
                            container: $(this).data('container'),
                            template: $(this).data('template')
                        });
                        $(this).draggable({
                            zIndex: 999,
                            revert: true,
                            revertDuration: 0,
                            start: (event) => vm.onDrag(event, vm),
                            stop: (event) => vm.onDrag(event, vm)
                        });
                    });
                }, 150);
            }
            onDrag(event, vm) {
                if (event.type === 'dragstart')
                    vm.isDragging = true;
                if (event.type === 'dragstop') {
                    vm.isDragging = false;
                    vm.hideTemplates();
                }
            }
            getCalendarHeight() {
                return $(window).height() * 0.6;
            }
            normalizeSchedulerPeriod(period) {
                const capitalized = period ? period.charAt(0).toUpperCase() + period.slice(1) : '';
                if (capitalized === 'Day' || capitalized === 'Week' || capitalized === 'Month')
                    return capitalized;
                return 'Month';
            }
            initSchedulerViewType() {
                this.rosterSettings.schedulerViewType = this.isMobile ? 'list' : 'timeline';
            }
            persistRosterSettings() {
                const settings = { ...this.rosterSettings };
                delete settings.schedulerViewType;
                QMC.Common.personalLocalStorage.setItem(this.localStorageItemName, JSON.stringify(settings));
            }
            normalizeSchedulerSettings() {
                const storedView = this.rosterSettings.defaultSchedulerView;
                if (storedView && (storedView.startsWith('timeline') || storedView.startsWith('list'))) {
                    this.rosterSettings.defaultSchedulerView = this.normalizeSchedulerPeriod(storedView.replace(/^(timeline|list)/, ''));
                }
                if (!['Day', 'Week', 'Month'].includes(this.rosterSettings.defaultSchedulerView))
                    this.rosterSettings.defaultSchedulerView = 'Month';
                this.initSchedulerViewType();
            }
            getFullCalendarViewName(viewType, period) {
                const type = viewType !== null && viewType !== void 0 ? viewType : this.rosterSettings.schedulerViewType;
                const schedulerPeriod = period !== null && period !== void 0 ? period : this.rosterSettings.defaultSchedulerView;
                return `${type}${schedulerPeriod}`;
            }
            parseFullCalendarViewName(viewName) {
                return {
                    viewType: viewName.startsWith('list') ? 'list' : 'timeline',
                    period: this.normalizeSchedulerPeriod(viewName.replace(/^(timeline|list)/, ''))
                };
            }
            setupCalendar(ressourceView = false) {
                // hide type column if there is only one (or less) resource type rows (services)
                //const hideTypeColumn = false;
                const resourceColumns = this.rosterResources.map(x => x.serviceType).filter((value, index, self) => self.indexOf(value) === index);
                const hideColumn = resourceColumns.length === 1 ? resourceColumns[0] : undefined;
                const scope = this;
                const nameDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '25%' : '35%';
                const typeDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '35%' : '65%';
                const currentValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '5%' : '0%';
                const plannedValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '5%' : '0%';
                const targetValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                const totalValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                const restHolidaysValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                const resourceAreaDefaultWidth = this.rosterSettings.showWorkingEventsInfo ? '40%' : '20%';
                this.resourceViewMobileCreated = ressourceView;
                let ressColumns = [
                    {
                        group: true,
                        labelText: this.lng.translate(20000072, 'Name'),
                        field: 'caption',
                        width: ressourceView && !this.rosterSettings.showWorkingEventsInfo ? '0%' : nameDefaultColumnSize,
                        render: (...args) => {
                            var _a, _b;
                            let parent;
                            let name;
                            let personId;
                            if (hideColumn) {
                                personId = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.referenceId;
                                parent = args[1];
                                name = args[2];
                            }
                            else {
                                parent = args[0];
                                name = args[1];
                                personId = (_b = this.rosterResources.find(x => x.caption === name)) === null || _b === void 0 ? void 0 : _b.referenceId;
                            }
                            parent.css('display', 'flex');
                            parent.css('align-items', 'center');
                            if (!this.wtOverviewPermission.moduleAccess)
                                return;
                            const button = $(document.createElement('i'));
                            button.hover(() => button.addClass('text-primary'), () => button.removeClass('text-primary'));
                            button.addClass('qm-icon-trafficlight_off');
                            button.attr('style', 'font-size: 2em; cursor: pointer; margin: -8px -5px; ');
                            button.attr('data-toggle', 'tooltip');
                            button.attr('data-placement', 'top');
                            button.attr('tag', '20001042');
                            button.attr('data-original-title', 'Arbeitszeitenübersicht');
                            // Add a unique class for easier targeting
                            button.addClass('wto-button');
                            button.attr('data-person-id', personId);
                            button.attr('data-person-name', name);
                            const cell = parent.find('.fc-cell-text');
                            cell.css('display', 'flex');
                            cell.css('alignItems', 'center');
                            cell.prepend(button[0]);
                        }
                    },
                    {
                        labelText: this.lng.translate(20000025, 'Typ'),
                        field: 'serviceType',
                        width: ressourceView && !this.rosterSettings.showWorkingEventsInfo ? '70%' : typeDefaultColumnSize
                    }
                ];
                if (hideColumn) {
                    ressColumns[0].width = '100%';
                    ressColumns[0].group = false;
                    ressColumns.pop();
                }
                if (this.rosterSettings.showWorkingEventsInfo) {
                    ressColumns = ressColumns.concat([
                        {
                            labelText: this.lng.translate(20028032, 'Ist'),
                            field: 'currentValue',
                            width: ressourceView ? '3%' : currentValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028033, 'Soll'),
                            field: 'plannedValue',
                            width: ressourceView ? '3%' : plannedValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028034, 'Vorgabe'),
                            field: 'targetValue',
                            width: ressourceView ? '8%' : targetValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028035, 'Gesamt'),
                            field: 'totalValue',
                            width: ressourceView ? '8%' : totalValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028036, 'Resturlaub'),
                            field: 'restHolidaysValue',
                            width: ressourceView ? '8%' : restHolidaysValueDefaultColumnSize
                        }
                    ]);
                }
                const useListViews = !ressourceView && this.rosterSettings.schedulerViewType === 'list';
                const calenderViews = useListViews ? 'listDay, listWeek, listMonth' : 'timelineDay, timelineWeek, timelineMonth';
                const defaultCalendarView = ressourceView
                    ? this.getFullCalendarViewName('timeline', this.rosterSettings.defaultSchedulerView)
                    : this.getFullCalendarViewName();
                $(ressourceView ? '#rosterCalendarRessources' : '#rosterCalendar').fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    contentHeight: this.getCalendarHeight,
                    defaultView: defaultCalendarView,
                    defaultDate: this.rosterSettings.dataFrom,
                    timezone: 'local',
                    locale: 'de',
                    firstDay: 1,
                    weekends: this.rosterSettings.showWeekends,
                    nowIndicator: true,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: (date) => { return moment(date).isoWeek(); },
                    views: {
                        month: {
                            titleFormat: 'MMMM YYYY',
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY',
                        },
                        day: {
                            titleFormat: 'dddd D.MMM'
                        }
                    },
                    columnFormat: 'ddd D.M',
                    header: {
                        left: ressourceView ? '' : 'prev,next today',
                        center: 'title',
                        right: ressourceView ? '' : calenderViews
                    },
                    timeFormat: 'H:mm',
                    buttonText: ressourceView ? null : {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    events: this.rosterEvents,
                    resources: this.rosterResources,
                    resourceColumns: ressColumns,
                    resourceAreaWidth: ressourceView ? '100%' : resourceAreaDefaultWidth,
                    slotLabelFormat: [
                        'KW', 'ddd DD', 'H:mm'
                    ],
                    slotWidth: 48,
                    editable: true,
                    eventStartEditable: true,
                    eventDurationEditable: true,
                    eventResourceEditable: true,
                    droppable: scope.permission.service.new,
                    eventResize: event => {
                        console.log("Event resize", event);
                    },
                    eventDrop: function (event, delta, revertFunc) {
                        var _a, _b, _c, _e, _f, _g, _h, _j, _k, _l, _m;
                        $('.popover.in').remove();
                        this.eventReference = { id: event.referenceId, name: (_b = (_a = scope.rosterData.filter(x => x.id === event.referenceId)[0]) === null || _a === void 0 ? void 0 : _a.caption) !== null && _b !== void 0 ? _b : '' };
                        if (event.serviceTypeId === Roster.Constants.SERVICE) {
                            scope.formState = 'edit';
                            scope.getService(event.objectId, event);
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_HOLIDAY) {
                            scope.holidayCalls.edit(event.objectId, (_c = event.start) === null || _c === void 0 ? void 0 : _c.toDate(), (_f = ((_e = event.end) !== null && _e !== void 0 ? _e : event.start)) === null || _f === void 0 ? void 0 : _f.toDate());
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_DISEASE) {
                            scope.sickLeaveCalls.edit(event.objectId, (_g = event.start) === null || _g === void 0 ? void 0 : _g.toDate(), (_j = ((_h = event.end) !== null && _h !== void 0 ? _h : event.start)) === null || _j === void 0 ? void 0 : _j.toDate());
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_EXEMPTION) {
                            scope.exemptionCalls.edit(event.objectId, (_k = event.start) === null || _k === void 0 ? void 0 : _k.toDate(), (_m = ((_l = event.end) !== null && _l !== void 0 ? _l : event.start)) === null || _m === void 0 ? void 0 : _m.toDate());
                        }
                        revertFunc();
                    },
                    drop: function (date, jsEvent, ui, resourceId) {
                        // resourceId is the subtype id on which was dropped
                        // You can get the dropped on row info by: $(this).data().event.services.filter(x=> x.id === resourceId)[0]
                        // In that result serviceTypeId and serviceTypeSubId are the real roster type ids
                        var _a;
                        let referenceId = null;
                        for (const data of scope.rosterData) {
                            for (const service of data.services) {
                                if (service.id === resourceId) {
                                    referenceId = data.id;
                                }
                            }
                        }
                        const data = $(this).data().event;
                        const reference = scope.rosterData.filter(x => x.id === referenceId)[0];
                        scope.eventReference = { id: referenceId, name: (_a = reference === null || reference === void 0 ? void 0 : reference.caption) !== null && _a !== void 0 ? _a : '', instituteId: reference === null || reference === void 0 ? void 0 : reference.instituteId };
                        const droppedRowData = reference.services.filter(x => x.id === resourceId)[0];
                        const droppedRowRosterType = { rosterTypeId: droppedRowData.serviceTypeId, rosterSubTypeId: droppedRowData.serviceSubTypeId };
                        scope.handleTemplateDrop(data.template, moment(date._d).toDate(), droppedRowRosterType);
                    },
                    eventReceive: (event) => {
                        //when any event is received, delete it right away, qmc logic will take care in drop/eventdrop
                        $(ressourceView ? '#rosterCalendarRessources' : '#rosterCalendar').fullCalendar('removeEvents', event._id);
                    },
                    eventClick: (event) => {
                        var _a;
                        this.validation.errors = [];
                        this.validation.warnings = [];
                        this.lastValidation = undefined;
                        const reference = this.rosterData.filter(x => x.id === event.referenceId)[0];
                        this.eventReference = { id: event.referenceId, name: (_a = reference === null || reference === void 0 ? void 0 : reference.caption) !== null && _a !== void 0 ? _a : '', instituteId: reference === null || reference === void 0 ? void 0 : reference.instituteId };
                        const serviceTypeId = event.serviceTypeId;
                        const serviceSubTypeId = event.serviceSubTypeId;
                        if (serviceTypeId === Roster.Constants.SERVICE) {
                            if (serviceSubTypeId === Roster.Constants.SUBTYPE_DOCUMENTED)
                                this.openExistingService(event.objectId);
                            if (serviceSubTypeId === Roster.Constants.SUBTYPE_PLANNED)
                                this.openExistingPlannedService(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_HOLIDAY) {
                            this.holidayCalls.edit(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_DISEASE) {
                            this.sickLeaveCalls.edit(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_EXEMPTION) {
                            this.exemptionCalls.edit(event.objectId);
                        }
                    },
                    viewRender: (view) => {
                        const dateToCheck = moment(view.start).startOf('day').toDate();
                        //the calendar is rendered many times, just reload completely the data when changing the dates
                        const needToReloadCompletely = moment(this.rosterSettings.dataFrom).format('YYYY-MM-DD') !== moment(dateToCheck).format('YYYY-MM-DD');
                        // remove time header row from month view
                        const row = $('.fc-time-area').find('tr')[2];
                        if (row !== (null || undefined) && view.name === 'timelineMonth')
                            row.setAttribute('style', 'display:none');
                        if (!this.keepData) {
                            const prev = {
                                dataFrom: this.rosterSettings.dataFrom,
                                dataTo: this.rosterSettings.dataTo
                            };
                            const dataFrom = moment(view.start);
                            let dataTo = moment(view.end);
                            //this.rosterSettings.dataFrom.setHours(0, 0, 0, 0);
                            switch (view.name) {
                                case 'timelineDay':
                                case 'listDay':
                                    dataTo = moment(view.start);
                                    break;
                                case 'timelineWeek':
                                case 'listWeek':
                                    dataTo = moment(view.start).endOf('week');
                                    break;
                                case 'timelineMonth':
                                case 'listMonth':
                                default:
                                    dataTo = moment(view.start).endOf('month');
                                    break;
                            }
                            this.rosterSettings.dataFrom = moment(dataFrom.startOf('day').format('YYYY-MM-DD HH:mm:ss')).toDate(); //make absolutely sure to get the date whithout timezone to match the server
                            this.rosterSettings.dataTo = moment(dataTo.endOf('day').format('YYYY-MM-DD HH:mm:ss')).toDate();
                            this.rosterSettings.viewDate = new Date(this.rosterSettings.dataFrom);
                            const parsedView = this.parseFullCalendarViewName(view.name);
                            this.rosterSettings.schedulerViewType = parsedView.viewType;
                            this.rosterSettings.defaultSchedulerView = parsedView.period;
                            const fromChanged = prev.dataFrom.getTime() !== this.rosterSettings.dataFrom.getTime();
                            const toChanged = prev.dataTo.getTime() !== this.rosterSettings.dataTo.getTime();
                            if (fromChanged || toChanged)
                                this.getRosterData(false);
                            else if (this.calendarCreated && !ressourceView && !this.calendarNoReload && needToReloadCompletely) {
                                this.getRosterData(true);
                            }
                        }
                        if (this.rosterSettings.highlightWeekends) {
                            if (view.name === 'timelineMonth') {
                                $('.fc-sat.fc-day').addClass('highlight-weekend');
                                $('.fc-sun.fc-day').addClass('highlight-weekend');
                            }
                            if (view.name === 'timelineWeek' || view.name === 'timelineDay') {
                                const days = document.getElementsByClassName('fc-widget-content');
                                [].forEach.call(days, (day) => {
                                    const date = this.$qui.createDateFromString(day.dataset.date);
                                    if (date.getDay() === 6 || date.getDay() === 0)
                                        day.classList.add('highlight-weekend');
                                });
                            }
                        }
                        this.calendarNoReload = false;
                    },
                    resourceRender: (resource, element) => {
                        element.closest('.fc-widget-content').attr('data-reference', resource.referenceId);
                        if (resource.serviceType.includes(resource.caption)) {
                            //if the view is per organisation or person lists make the cell content text bold, better view
                            element[1].querySelector('.fc-cell-text').setAttribute("style", "font-weight: bold");
                        }
                    },
                    eventRender: (event, element, view) => {
                        if (view.name === 'timelineMonth') {
                            element[0].textContent = event.title;
                        }
                        let timeString = moment(event.start).format('HH:mm');
                        if (event.end) {
                            timeString += "-" + moment(event.end).format('HH:mm');
                            if (moment(event.start).format('DD.MM') !== moment(event.end).format('DD.MM'))
                                timeString = moment(event.start).format('DD.MM HH:mm') + ' - ' + moment(event.end).format('DD.MM HH:mm');
                        }
                        const eventTypeCaption = event.captionEventType ? "(" + event.captionEventType + ")" : "";
                        if (!event.noPopover) {
                            element.popover({
                                animation: true,
                                html: true,
                                delay: 300,
                                content: event.title !== '' ? `${event.fullTitle} (${event.title}) ${eventTypeCaption}:<br /> ${timeString}` : `${event.fullTitle}<br /> ${timeString}`,
                                trigger: 'hover',
                                placement: 'bottom',
                                container: 'body'
                            });
                        }
                    },
                    dayClick: (date, jsEvent, view, resourceObj) => {
                        $('.popover.in').remove();
                        const singleClick = moment(date).toISOString();
                        if (this.dblClick === singleClick) {
                            const calendarInfo = {
                                date: singleClick,
                                timeFrom: view.name === "timelineDay" || view.name === "timelineWeek" ? moment(date).minutes(0).toDate() : null,
                                timeTo: view.name === "timelineDay" || view.name === "timelineWeek" ? moment(date).minutes(0).toDate() : null,
                                referenceRessource: resourceObj.referenceId,
                                referenceInstituteId: resourceObj.referenceInstituteId
                            };
                            const isLockedForDate = this.isDateLockedForType(resourceObj.referenceId, Roster.Constants.SUBTYPE_DOCUMENTED, date, date);
                            if (!isLockedForDate) {
                                this.initNewForm(null, calendarInfo);
                                $('#new-service-modal').modal('show');
                            }
                            this.dblClick = null;
                        }
                        else {
                            this.dblClick = moment(date).toISOString();
                            clearInterval(this.clickTimer);
                            this.clickTimer = setInterval(function () {
                                this.dblClick = null;
                                clearInterval(this.clickTimer);
                            }, 500);
                        }
                    }
                });
                // Add event delegation for WTO buttons
                $(document).on('click', '.wto-button', (event) => {
                    const button = $(event.target);
                    const personId = button.attr('data-person-id');
                    const personName = button.attr('data-person-name');
                    this.wtoData = undefined;
                    $('#wtoModal').modal('show');
                    this.wtoData = {
                        personId: personId,
                        name: personName
                    };
                    this.$qui.scopeApply(this.$scope);
                });
            }
            preventNegativeTimePeriods() {
                const dateFrom = this.$qui.addTimeToDate(this.serviceForm.dateFrom, this.serviceForm.timeFrom);
                const dateTo = this.$qui.addTimeToDate(this.serviceForm.dateTo, this.serviceForm.dateTo);
                if (dateTo < dateFrom) {
                    this.isNegativeTimePeriodLock = true;
                    this.validation.errors = this.isNegativeTimePeriodLock ? [this.lng.translate(20028027, 'Negative Zeiträume sind nicht zulässig.')] : [];
                }
                else {
                    this.isNegativeTimePeriodLock = false;
                }
            }
        };
        RosterController = __decorate([
            QMC.Controller('QMC.Roster', 'RosterController'),
            QMC.Inject('$location', 'RosterService', '$qui', '$scope', '$stateParams', '$state', 'QmcLanguageService', 'QmcPermissionService', 'KlientService', 'UserService', '$compile', '$timeout')
        ], RosterController);
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        class SickLeaveFormDirective {
            constructor(scope, rosterService, $qui, lng, $timeout) {
                this.scope = scope;
                this.rosterService = rosterService;
                this.$qui = $qui;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = 'sickLeave_' + Math.random().toString(36).substring(2, 11);
                this.formState = 'new';
                this.pauseWatchers = false;
                this.formInvalid = true;
                this.calcedValues = { days: 0, hours: 0 };
                this.validation = { errors: [], warnings: [], loading: false };
                this.promptOptions = {
                    title: this.lng.translate(20028038, 'Krankheit'),
                    yesNo: true,
                    icon: 'qm-icon-mail_virus',
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.$postLink = () => {
                    this.calls = {
                        new: (form) => {
                            var _a;
                            this.initForm();
                            this.formState = 'new';
                            this.lastValidation = undefined;
                            this.validation.errors = [];
                            this.validation.warnings = [];
                            if (form) {
                                this.form = { ...form, isManualDays: true, isManualHours: false, isAccountServices: false };
                                //ensure every form has valid ids for it gets referenced by sickNotes
                                const newId = this.$qui.generateGuid();
                                if (!this.form.id)
                                    this.form.id = (_a = this.form.objectId) !== null && _a !== void 0 ? _a : newId;
                                if (!this.form.objectId)
                                    this.form.objectId = this.form.id;
                            }
                            if (!this.form.sickNotes)
                                this.form.sickNotes = [];
                            this.calls.open();
                        },
                        edit: (form, start, end) => {
                            var _a;
                            this.formState = 'edit';
                            this.lastValidation = undefined;
                            this.validation.errors = [];
                            this.validation.warnings = [];
                            if (typeof form === 'string') {
                                this.loadSickLeave(form, start, end);
                            }
                            else {
                                this.pauseWatchers = true;
                                this.form = (_a = { ...form, isManualDays: true, isManualHours: false, isAccountServices: false }) !== null && _a !== void 0 ? _a : this.form;
                                if (start)
                                    this.form.dateFrom = start;
                                if (end)
                                    this.form.dateTo = end;
                                setTimeout(() => { this.pauseWatchers = false; }, 50);
                            }
                            this.calls.open();
                        },
                        delete: (form) => { this.deleteSickLeave(form !== null && form !== void 0 ? form : this.form); },
                        open: () => {
                            $('#' + this.id).modal('show');
                            this.validate();
                            this.createInterface();
                            setTimeout(() => { $(`#${this.id}`).find(`#standardTabButton_${this.id}`).click(); }, 50);
                            this.$qui.scopeApply(this.scope);
                        },
                        close: () => { $('#' + this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = () => {
                    $('#' + this.id).remove();
                    $('#sickNote_' + this.id).remove();
                };
                this.uiForm = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                displayTime: true,
                                disableTime: false,
                                disableDate: false
                            }
                        },
                        {
                            label: "Art",
                            type: "Select2",
                            lngTag: 20000138,
                            model: "diseaseKindId",
                            dataSource: "getDiseaseKinds",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: `qmForm.serviceSubTypeId !== '${Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD}'`
                            }
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            disabled: true,
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            events: {
                                hideExpression: `qmForm.serviceSubTypeId === '${Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD}'`
                            }
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            events: {
                                hideExpression: `qmForm.serviceSubTypeId !== '${Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD}'`
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20000053,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "captionShort",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Erbringungsort",
                            type: "Select2",
                            lngTag: 20028006,
                            model: "instituteId",
                            dataSource: "getInstitutes",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: 'hr'
                        },
                        {
                            label: "Anzahl Tage",
                            type: "CheckboxInline",
                            lngTag: 20020026,
                            model: "isManualDays",
                            id: "isManualDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: true,
                            id: "amountOfDaysDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "qmForm.isManualDays"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: false,
                            id: "amountOfDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "!qmForm.isManualDays"
                            }
                        },
                        {
                            label: "Anzahl Stunden",
                            type: "CheckboxInline",
                            lngTag: 20020027,
                            model: "isManualHours",
                            id: "isManualHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: true,
                            id: "amountOfHoursDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmForm.isManualHours"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: false,
                            id: "amountOfHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "!qmForm.isManualHours"
                            }
                        },
                        {
                            label: "Dienste anrechnen",
                            type: "CheckboxInline",
                            lngTag: 20020024,
                            model: "isAccountServices",
                            id: "isAccountServices",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            type: 'hr'
                        },
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        },
                    ]
                };
                this.sickNoteLoading = false;
                this.sickNoteFormState = 'new';
                this.uiSickNoteForm = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                disableDate: false
                            },
                            required: true
                        },
                        {
                            label: "Art der Krankmeldung",
                            type: "Select2",
                            lngTag: 20028044,
                            model: "typeOfSickNoteId",
                            dataSource: "getSickNoteKinds",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20000053,
                            model: "caption",
                            style: {
                                class: "col-xs-12"
                            },
                            required: true
                        },
                        {
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Dokumente",
                            type: "Documents",
                            lngTag: "21006000",
                            documentFolderStructure: {
                                documentObjectType: "documentObjectType",
                                objectType: "objectType",
                                parentId: "objectId"
                            },
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: 'createSickNote',
                        put: 'updateSickNote',
                        delete: 'deleteSickNote'
                    }
                };
                this.init();
                this.events();
            }
            init() {
                this.rosterService.getSickLeaveWv().then((data) => {
                    this.wvList = data;
                });
                this.rosterService.getInstituteList().then((data) => {
                    this.institutes = data;
                });
                this.initForm();
            }
            events() {
                this.scope.$watch('vm.form.diseaseKindId', (newValue, oldValue) => {
                    var _a;
                    if (newValue === oldValue || !newValue)
                        return;
                    const intColor = (_a = this.wvList.diseaseKindWvList.filter(x => x.objectId === newValue)[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!intColor)
                        return;
                    this.form.color = '#' + ('000000' + (intColor & 0xFFFFFF).toString(16)).slice(-6);
                });
                this.scope.$watch('vm.form.isManualDays', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualHours = false;
                    this.form.isAccountServices = false;
                    this.form.accountingTypeFlag = 0;
                });
                this.scope.$watch('vm.form.isManualHours', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualDays = false;
                    this.form.isAccountServices = false;
                    this.form.accountingTypeFlag = 1;
                });
                this.scope.$watch('vm.form.isAccountServices', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualDays = false;
                    this.form.isManualHours = false;
                    this.form.accountingTypeFlag = 2;
                });
                this.scope.$watch('vm.form.dateFrom', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    this.getCalcDayValues();
                });
                this.scope.$watch('vm.form.dateTo', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    this.getCalcDayValues();
                });
                this.scope.$watch('vm.form', () => {
                    this.$timeout(() => {
                        this.formInvalid = $(`#${this.id}`).find(`#baseDataTab_${this.id}`).find('.ng-invalid').length > 0;
                    });
                    if (!this.pauseWatchers) {
                        this.validate();
                    }
                }, true);
            }
            initForm() {
                var _a, _b, _c, _d;
                const newId = this.$qui.generateGuid();
                this.form = {
                    id: newId,
                    objectId: newId,
                    comment: '',
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    color: '#0000FF',
                    amountOfDays: 0,
                    amountOfHours: 0,
                    accountingTypeFlag: 0,
                    caption: '',
                    captionShort: '',
                    diseaseKindId: null,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    instituteId: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _d !== void 0 ? _d : null,
                    serviceSubTypeId: Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD,
                    isAccountServices: false,
                    isManualDays: true,
                    isManualHours: false
                };
            }
            getDiseaseKinds() {
                var _a, _b, _c;
                return (_c = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.diseaseKindWvList) === null || _b === void 0 ? void 0 : _b.map(x => ({ text: x.name, value: x.objectId }))) !== null && _c !== void 0 ? _c : [];
            }
            getSickNoteKinds() {
                var _a, _b, _c;
                return (_c = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.sickNoteKindWvList) === null || _b === void 0 ? void 0 : _b.map(x => ({ text: x.name, value: x.objectId }))) !== null && _c !== void 0 ? _c : [];
            }
            getInstitutes() {
                var _a, _b;
                return (_b = (_a = this.institutes) === null || _a === void 0 ? void 0 : _a.map(x => ({ text: x.caption, value: x.objectId }))) !== null && _b !== void 0 ? _b : [];
            }
            getPermission() {
                if (this.form && this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT)
                    return this.permissions.accident;
                if (this.form && this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD)
                    return this.permissions.standard;
                return {};
            }
            isEditAllowed() {
                var _a, _b, _c, _d, _e, _f, _g;
                if (this.formState === 'new')
                    return (_b = (_a = this.getPermission()) === null || _a === void 0 ? void 0 : _a.new) !== null && _b !== void 0 ? _b : false;
                if (this.formState === 'edit')
                    return (_g = (_e = (_d = (_c = this.form) === null || _c === void 0 ? void 0 : _c.permissions) === null || _d === void 0 ? void 0 : _d.modify) !== null && _e !== void 0 ? _e : (_f = this.getPermission()) === null || _f === void 0 ? void 0 : _f.modify) !== null && _g !== void 0 ? _g : false;
                return false;
            }
            getCalcDayValues() {
                if (!this.form.isManualDays)
                    return;
                this.rosterService.calculateDayValues(this.form.dateFrom, this.form.dateTo, this.reference.id).then((data) => {
                    this.form.amountOfDays = data.calcDays;
                    if (!this.form.isManualHours)
                        this.form.amountOfHours = 0;
                });
            }
            getButtonClass() {
                if (this.validation.errors.length > 0)
                    return 'btn-danger';
                if (this.validation.warnings.length > 0)
                    return 'btn-warning';
                return 'btn-primary';
            }
            loadSickLeave(id, start, end) {
                if (!id)
                    return;
                this.loading = true;
                this.rosterService.getSickLeave(id).then((data) => {
                    this.pauseWatchers = true;
                    if (start)
                        data.dateFrom = start;
                    if (end)
                        data.dateFrom = end;
                    data.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    data.dateTo = this.$qui.createDateFromString(data.dateTo);
                    switch (data.accountingTypeFlag) {
                        case 1:
                            data.isManualHours = true;
                            break;
                        case 2:
                            data.isAccountServices = true;
                            break;
                        default:
                            data.isManualDays = true;
                            break;
                    }
                    this.form = data;
                    this.createInterface();
                    setTimeout(() => {
                        this.pauseWatchers = false;
                        $(`#${this.id}`).find(`#standardTabButton_${this.id}`).click();
                    }, 50);
                }).finally(() => this.loading = false);
            }
            createInterface() {
                if (!this.form)
                    return;
                if (!this.form.id)
                    this.form.id = this.$qui.generateGuid();
                if (this.form.objectId)
                    this.form.objectId = this.form.id;
                this.$qui.functionWaiter('createForm', this);
            }
            addSickLeave(form) {
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.getPermission().new)
                    return;
                if (form.isManualDays)
                    form.accountingTypeFlag = 0;
                if (form.isManualHours)
                    form.accountingTypeFlag = 1;
                if (form.isAccountServices)
                    form.accountingTypeFlag = 2;
                this.loading = true;
                this.rosterService.postSickLeave(form).then(() => {
                    this.calls.close();
                    this.callbacks().onNew(form);
                }).finally(() => this.loading = false);
            }
            updateSickLeave(form) {
                var _a;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!((_a = this.form.permissions) === null || _a === void 0 ? void 0 : _a.modify))
                    return;
                if (form.isManualDays)
                    form.accountingTypeFlag = 0;
                if (form.isManualHours)
                    form.accountingTypeFlag = 1;
                if (form.isAccountServices)
                    form.accountingTypeFlag = 2;
                this.loading = true;
                this.rosterService.putSickLeave(form.objectId, form).then(() => {
                    this.calls.close();
                    this.callbacks().onEdit(form);
                }).finally(() => this.loading = false);
            }
            deleteSickLeave(form) {
                var _a;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!((_a = this.form.permissions) === null || _a === void 0 ? void 0 : _a.delete))
                    return;
                this.promptOptions.title = this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD ? this.lng.translate(20028038, 'Krankheit') : this.lng.translate(20028039, 'Arbeitsunfall');
                this.promptOptions.itemText = `${form.caption} (${moment(form.dateFrom).format('DD.MM.yyyy HH:mm')} - ${moment(form.dateTo).format('DD.MM.yyyy HH:mm')})`;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.rosterService.deleteSickLeave(form.objectId).then(() => {
                        this.calls.close();
                        this.callbacks().onDelete(form);
                    }).finally(() => this.loading = false);
                }, `#prompt_${this.id}`);
            }
            validate() {
                var _a, _b, _c, _d;
                if (!this.form)
                    return;
                const validationForm = {
                    entryId: this.form.objectId,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    reference: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    serviceTypeId: Roster.Constants.SERVICE_TYPE_DISEASE,
                    serviceSubTypeId: this.form.serviceSubTypeId,
                    randomId: Math.random().toString(36).substring(2, 11)
                };
                if (this.lastValidation) {
                    const last = angular.copy(this.lastValidation);
                    const current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation.loading = true;
                this.rosterService.validateNonService(validationForm).then((data) => {
                    if (this.lastValidation.randomId === validationForm.randomId) {
                        this.validation = {
                            errors: data.errors,
                            warnings: data.warnings,
                            loading: false
                        };
                    }
                }).catch(() => {
                    this.validation = {
                        errors: [this.lng.translate(20028043, 'Es konnte nicht validiert werden')],
                        warnings: [],
                        loading: false
                    };
                });
            }
            newSickNote(form) {
                this.sickNoteForm = form;
                this.sickNoteFormState = 'new';
                // ensure every sickNote has valid ids, for they get referenced by the actual documents
                const newId = this.$qui.generateGuid();
                this.sickNoteForm = {
                    caption: '',
                    comment: '',
                    dateFrom: moment(this.form.dateFrom).startOf('day').toDate(),
                    dateTo: moment(this.form.dateTo).endOf('day').toDate(),
                    id: newId,
                    objectId: newId,
                    typeOfSickNoteId: Roster.Constants.SERVICE_SICKNOTETYPE_INITIALDOCUMENT,
                    typeOfSickNoteCaption: '',
                    parentObjectType: this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD ? 411004 : 411006
                };
                this.openSickNoteModal();
            }
            openSickNoteModal() {
                this.sickNoteForm.objectType = 411008;
                this.sickNoteForm.documentObjectType = 411009;
                this.$qui.functionWaiter('createSickNoteForm', this);
                $('#sickNote_' + this.id).modal('show');
            }
            closeSickNoteModal() {
                $('#sickNote_' + this.id).modal('hide');
            }
            openSickNote(form) {
                this.sickNoteForm = form;
                this.sickNoteFormState = 'edit';
                this.openSickNoteModal();
            }
            createSickNote(form) {
                if (this.formState === 'new') {
                    form.permissions = this.permissions.document;
                    this.form.sickNotes.push(form);
                }
                else {
                    this.sickNoteLoading = true;
                    this.rosterService.postSickNote(this.form.objectId, form).then(() => {
                        this.closeSickNoteModal();
                        this.getSickNotes();
                    }).finally(() => this.sickNoteLoading = false);
                }
            }
            updateSickNote(form) {
                if (this.formState === 'new') {
                    this.form.sickNotes = this.form.sickNotes.filter(x => x.objectId !== form.objectId);
                    this.form.sickNotes.push(form);
                }
                else {
                    this.sickNoteLoading = true;
                    this.rosterService.putSickNote(this.form.objectId, form.objectId, form).then(() => {
                        this.closeSickNoteModal();
                        this.getSickNotes();
                    }).finally(() => this.sickNoteLoading = false);
                }
            }
            getSickNotes() {
                this.sickNoteLoading = true;
                this.rosterService.getSickNoteList(this.form.objectId).then(data => {
                    this.form.sickNotes = data;
                }).finally(() => this.sickNoteLoading = false);
            }
            deleteSickNote(form) {
                var _a;
                if (!((_a = form.permissions) === null || _a === void 0 ? void 0 : _a.delete))
                    return;
                this.promptOptions.itemText = `${form.caption} (${moment(form.dateFrom).format('DD.MM.yyyy')} - ${moment(form.dateTo).format('DD.MM.yyyy')})`;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    if (this.formState === 'new') {
                        this.form.sickNotes = this.form.sickNotes.filter(x => x.objectId !== form.objectId);
                    }
                    else {
                        this.sickNoteLoading = true;
                        this.rosterService.deleteSickNote(this.form.objectId, form.objectId).then(() => {
                            this.closeSickNoteModal();
                            this.getSickNotes();
                        }).finally(() => this.sickNoteLoading = false);
                    }
                }, `#prompt_${this.id}`);
            }
        }
        angular.module('QMC.Roster').component('qmSickLeaveForm', {
            templateUrl: './Roster/SickLeaveFormDirective',
            controller: ['$scope', 'RosterService', '$qui', 'QmcLanguageService', '$timeout', SickLeaveFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '&',
                reference: '=',
            }
        });
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        class ExemptionFormDirective {
            constructor(scope, $qui, rosterService, lng, $timeout) {
                this.scope = scope;
                this.$qui = $qui;
                this.rosterService = rosterService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = '_' + Math.random().toString(36).substr(2, 9);
                this.formState = 'new';
                this.pauseWatchers = false;
                this.validation = { errors: [], warnings: [], loading: false };
                this.promptOptions = {
                    title: this.lng.translate(20028042, 'Freistellung'),
                    yesNo: true,
                    icon: 'qm-icon-mail-virus',
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.$postLink = () => {
                    this.calls = {
                        new: (form) => {
                            this.initForm();
                            this.formState = 'new';
                            if (form) {
                                this.form = form;
                            }
                            this.calls.open();
                        },
                        edit: (form, start, end) => {
                            this.formState = 'edit';
                            if (typeof form === 'string') {
                                this.loadExemption(form, start, end);
                            }
                            else {
                                this.pauseWatchers = true;
                                this.form = form;
                                if (start)
                                    this.form.dateFrom = start;
                                if (end)
                                    this.form.dateTo = end;
                                setTimeout(() => { this.pauseWatchers = false; }, 50);
                            }
                            this.calls.open();
                        },
                        delete: (form) => { this.deleteExemption(form !== null && form !== void 0 ? form : this.form); },
                        open: () => {
                            $('#' + this.id).modal('show');
                            this.validate();
                            this.createInterface();
                            this.$qui.scopeApply(this.scope);
                            this.$qui.waitForEl(`#${this.id}_standardTabButton`, () => {
                                $(`#${this.id}_standardTabButton`).click();
                            });
                        },
                        close: () => { $('#' + this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = () => {
                    $('#' + this.id).remove();
                };
                this.formSchema = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                displayTime: true,
                                disableTime: false,
                                disableDate: false
                            }
                        },
                        {
                            label: "Art",
                            type: "Select2",
                            model: "exemptionKindId",
                            lngTag: 20000138,
                            dataSource: "getExemptionKindList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            model: "caption",
                            lngTag: 20000053,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Kürzel",
                            type: "String",
                            model: "captionShort",
                            lngTag: 20000221,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erbringungsort",
                            type: "Select2",
                            dataSource: "getInstitutes",
                            model: "instituteId",
                            lngTag: 20028006,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            id: "approvedId",
                            lngTag: 20020007,
                            events: {
                                hideExpression: "!qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            disabled: true,
                            events: {
                                hideExpression: "qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }
                    ],
                    actions: {
                        put: "updateExemption",
                        post: "addExemption",
                        delete: "deleteExemption"
                    }
                };
                this.init();
                this.events();
            }
            validate() {
                var _a, _b, _c, _d;
                if (!this.form)
                    return;
                const validationForm = {
                    entryId: this.form.objectId,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    reference: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    serviceTypeId: Roster.Constants.SERVICE_TYPE_EXEMPTION,
                    serviceSubTypeId: Roster.Constants.SERVICE_TYPE_EXEMPTION,
                    randomId: Math.random().toString(36).substring(2, 11)
                };
                if (this.lastValidation) {
                    const last = angular.copy(this.lastValidation);
                    const current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation.loading = true;
                this.rosterService.validateNonService(validationForm).then((data) => {
                    if (this.lastValidation.randomId === validationForm.randomId) {
                        this.validation = {
                            errors: data.errors,
                            warnings: data.warnings,
                            loading: false
                        };
                    }
                }).catch(() => {
                    this.validation = {
                        errors: [this.lng.translate(20028043, 'Es konnte nicht validiert werden')],
                        warnings: [],
                        loading: false
                    };
                });
            }
            formatForm() {
                if (this.form) {
                    this.form.approved = this.getApprovementWvItem(this.form.approvedId);
                    this.form.permissionApproved = this.permissions.approved.openFile;
                }
            }
            init() {
                this.rosterService.getExemptionWv().then((data) => {
                    this.wvList = data;
                });
                this.rosterService.getInstituteList().then((data) => {
                    this.institutes = data;
                });
                this.initForm();
            }
            getInstitutes() {
                var _a, _b;
                return (_b = (_a = this.institutes) === null || _a === void 0 ? void 0 : _a.map(x => ({ text: x.caption, value: x.objectId }))) !== null && _b !== void 0 ? _b : [];
            }
            events() {
                this.scope.$watch('vm.form.exemptionKindId', (newValue, oldValue) => {
                    var _a;
                    if (newValue === oldValue || !newValue)
                        return;
                    const intColor = (_a = this.wvList.exemptionKindWvList.filter(x => x.objectId === newValue)[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!intColor)
                        return;
                    this.form.color = '#' + ('000000' + (intColor & 0xFFFFFF).toString(16)).slice(-6);
                });
                this.scope.$watch('vm.form.dateFrom', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                });
                this.scope.$watch('vm.form.dateTo', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                });
                this.scope.$watch('vm.form', () => {
                    if (!this.pauseWatchers) {
                        this.validate();
                    }
                }, true);
            }
            initForm() {
                var _a, _b, _c, _d;
                const newId = this.$qui.generateGuid();
                this.form = {
                    id: newId,
                    objectId: newId,
                    referenceId: this.scope.referenceId,
                    caption: this.lng.translate(20028042, 'Freistellung'),
                    color: '#0000FF',
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    comment: '',
                    captionShort: '',
                    exemptionKindId: null,
                    instituteId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.instituteId) !== null && _b !== void 0 ? _b : null,
                    permissionApproved: (_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.approved) === null || _d === void 0 ? void 0 : _d.openFile,
                    approvedId: null,
                    approvedById: null
                };
            }
            getApprovementWvList() {
                return this.wvList.approvementTypeWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getApprovementWvItem(approvedId) {
                var _a, _b;
                const result = this.wvList.approvementTypeWvList.filter(item => item.objectId === approvedId);
                return result ? (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' : '';
            }
            getExemptionKindList() {
                const result = this.wvList.exemptionKindWvList.map(x => ({ text: x.name, value: x.objectId }));
                result.unshift({ text: '', value: QMC.Common.Constants.GUID_EMPTY });
                return result;
            }
            loadExemption(id, start, end) {
                if (!id)
                    return;
                this.loading = true;
                this.rosterService.getExemption(id).then((data) => {
                    this.pauseWatchers = true;
                    if (start)
                        data.dateFrom = start;
                    if (end)
                        data.dateFrom = end;
                    data.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    data.dateTo = this.$qui.createDateFromString(data.dateTo);
                    this.form = data;
                    this.formatForm();
                    this.createInterface();
                    setTimeout(() => {
                        this.pauseWatchers = false;
                    }, 50);
                }).finally(() => this.loading = false);
            }
            createInterface() {
                if (!this.form)
                    return;
                this.$qui.functionWaiter('createForm', this);
            }
            addExemption(form) {
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.permissions.standard.new)
                    return;
                this.loading = true;
                this.rosterService.postExemption(form).then(() => {
                    this.calls.close();
                    this.callbacks.onNew(form);
                }).finally(() => this.loading = false);
            }
            updateExemption(form) {
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.form.permissions.modify)
                    return;
                this.loading = true;
                this.rosterService.putExemption(form.objectId, form).then(() => {
                    this.calls.close();
                    this.callbacks.onEdit(form);
                }).finally(() => this.loading = false);
            }
            deleteExemption(form) {
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.form.permissions.delete)
                    return;
                this.promptOptions.title = this.lng.translate(20028042, 'Freistellung');
                this.promptOptions.itemText = `${form.caption} (${moment(form.dateFrom).format('DD.MM.yyyy HH:mm')} - ${moment(form.dateTo).format('DD.MM.yyyy HH:mm')})`;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.rosterService.deleteExemption(form.objectId).then(() => {
                        this.calls.close();
                        this.callbacks.onDelete(form);
                    }).finally(() => this.loading = false);
                }, `#prompt_${this.id}`);
            }
        }
        angular.module('QMC.Roster').component('qmExemptionForm', {
            templateUrl: './Roster/ExemptionForm',
            controller: ['$scope', '$qui', 'RosterService', 'QmcLanguageService', '$timeout', ExemptionFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '=',
                reference: '='
            }
        });
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        /** Set to false to skip client-side deviation validation (/Validation API calls on open and save). */
        const DEVIATION_CLIENT_VALIDATION_ENABLED = true;
        class ServiceDeviationTabDirective {
            constructor(scope, rosterService, $qui, lng) {
                this.scope = scope;
                this.rosterService = rosterService;
                this.$qui = $qui;
                this.lng = lng;
                this.id = 'serviceDeviation_' + Math.random().toString(36).substring(2, 11);
                this.loading = false;
                this.formState = 'new';
                this.serviceSubTypes = [];
                this.serviceAdditionals = [];
                this.institutes = [];
                this.deviations = [];
                this.deviationFormState = 'new';
                this.ignoreWarnings = false;
                this.validation = { errors: [], warnings: [], loading: false };
                this.saving = false;
                this.promptOptions = {
                    title: this.lng.translate(20028045, 'Abweichung'),
                    yesNo: true,
                    icon: 'qm-icon-chart_gantt',
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.$onInit = () => {
                    this.syncDeviations();
                    this.scope.$watch('vm.deviations', (newVal) => {
                        if (newVal) {
                            this.updateBreakDeviationMinutes();
                        }
                    }, true);
                };
                this.$onChanges = (changes) => {
                    if (changes.serviceId || changes.formState || changes.pendingDeviations) {
                        this.syncDeviations();
                    }
                };
                this.$onDestroy = () => {
                    $('#deviationModal_' + this.id).remove();
                    $('#breakModal_' + this.id).remove();
                    if (this.breakDeviationSummary) {
                        this.breakDeviationSummary.minutes = 0;
                    }
                };
            }
            updateBreakDeviationMinutes() {
                var _a;
                if (!this.breakDeviationSummary)
                    return;
                const getTimeSpan = (deviation) => {
                    return moment(deviation.dateTo).diff(moment(deviation.dateFrom), 'minutes');
                };
                this.breakDeviationSummary.minutes = ((_a = this.deviations) !== null && _a !== void 0 ? _a : [])
                    .filter((deviation) => deviation.typeId === Roster.Constants.DEVIATION_TYPE_BREAK)
                    .reduce((sum, deviation) => sum + (Number(deviation.break) || 0) + getTimeSpan(deviation), 0);
            }
            syncDeviations() {
                var _a;
                if (this.formState === 'new') {
                    this.deviations = (_a = this.pendingDeviations) !== null && _a !== void 0 ? _a : [];
                    return;
                }
                if (this.serviceId && this.serviceId !== QMC.Common.Constants.GUID_EMPTY) {
                    this.loadDeviations();
                }
                else {
                    this.deviations = [];
                }
            }
            loadDeviations() {
                this.loading = true;
                this.rosterService.getDeviations(this.serviceId).then((data) => {
                    this.deviations = data !== null && data !== void 0 ? data : [];
                }).finally(() => {
                    this.loading = false;
                    this.$qui.scopeApply(this.scope);
                });
            }
            getTypeCaption(typeId) {
                var _a, _b;
                if (!typeId || typeId === QMC.Common.Constants.GUID_EMPTY)
                    return '';
                return (_b = (_a = this.serviceSubTypes.filter(x => x.value === typeId)[0]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
            }
            isInvalidDateRange(form = this.deviationForm) {
                if (!(form === null || form === void 0 ? void 0 : form.dateFrom) || !(form === null || form === void 0 ? void 0 : form.dateTo) || !(form === null || form === void 0 ? void 0 : form.timeFrom) || !(form === null || form === void 0 ? void 0 : form.timeTo))
                    return false;
                const payload = this.buildCreatePayload(form);
                return moment(payload.dateFrom).isAfter(moment(payload.dateTo));
            }
            createBreakDeviationForm(objectId, timeFrom, timeTo) {
                var _a;
                return {
                    id: objectId,
                    objectId,
                    dateFrom: this.parentServiceForm.dateFrom,
                    dateTo: this.parentServiceForm.dateFrom,
                    timeFrom,
                    timeTo,
                    caption: '',
                    captionShort: '',
                    color: (_a = this.parentServiceForm.color) !== null && _a !== void 0 ? _a : '#FF6633',
                    comment: '',
                    instituteId: this.parentServiceForm.instituteId,
                    break: 0,
                    typeId: Roster.Constants.DEVIATION_TYPE_BREAK,
                    additionalWvIds: []
                };
            }
            newDeviation() {
                var _a, _b;
                if (!this.parentServiceForm)
                    return;
                const newId = this.$qui.generateGuid();
                this.deviationFormState = 'new';
                this.ignoreWarnings = false;
                this.validation.errors = [];
                this.validation.warnings = [];
                this.deviationForm = {
                    id: newId,
                    objectId: newId,
                    dateFrom: this.parentServiceForm.dateFrom,
                    dateTo: this.parentServiceForm.dateTo,
                    timeFrom: this.parentServiceForm.timeFrom,
                    timeTo: this.parentServiceForm.timeTo,
                    caption: '',
                    captionShort: '',
                    color: (_a = this.parentServiceForm.color) !== null && _a !== void 0 ? _a : '#FF6633',
                    comment: '',
                    instituteId: this.parentServiceForm.instituteId,
                    break: (_b = this.parentServiceForm.break) !== null && _b !== void 0 ? _b : 0,
                    typeId: null,
                    additionalWvIds: []
                };
                this.openDeviationModal();
            }
            newBreakDeviation() {
                if (!this.parentServiceForm)
                    return;
                const newId = this.$qui.generateGuid();
                this.deviationFormState = 'new';
                this.ignoreWarnings = false;
                this.validation.errors = [];
                this.validation.warnings = [];
                this.deviationForm = this.createBreakDeviationForm(newId, this.parentServiceForm.timeFrom, this.parentServiceForm.timeTo);
                this.openBreakModal();
            }
            openDeviation(deviation) {
                var _a;
                this.deviationFormState = 'edit';
                this.ignoreWarnings = false;
                this.validation.errors = [];
                this.validation.warnings = [];
                this.deviationForm = {
                    ...deviation,
                    dateFrom: this.$qui.createDateFromString(deviation.dateFrom),
                    dateTo: this.$qui.createDateFromString(deviation.dateTo),
                    timeFrom: this.$qui.createDateFromString(deviation.dateFrom),
                    timeTo: this.$qui.createDateFromString(deviation.dateTo),
                    additionalWvIds: (_a = deviation.additionalWvIds) !== null && _a !== void 0 ? _a : []
                };
                this.openDeviationModal();
            }
            openDeviationModal() {
                this.saving = false;
                $('#deviationModal_' + this.id).modal('show');
                this.validateDeviationForm(false);
            }
            openBreakModal() {
                this.saving = false;
                $('#breakModal_' + this.id).modal('show');
                this.validateDeviationForm(false);
            }
            closeDeviationModal() {
                const $deviationModal = $('#deviationModal_' + this.id);
                const $breakModal = $('#breakModal_' + this.id);
                let pendingHidden = 0;
                const onHidden = () => {
                    pendingHidden--;
                    if (pendingHidden <= 0) {
                        this.endSave();
                    }
                };
                [$deviationModal, $breakModal].forEach(($modal) => {
                    if ($modal.is(':visible')) {
                        pendingHidden++;
                        $modal.one('hidden.bs.modal', onHidden);
                    }
                });
                $deviationModal.modal('hide');
                $breakModal.modal('hide');
                if (pendingHidden === 0) {
                    this.endSave();
                }
            }
            beginSave() {
                this.saving = true;
                this.validation.loading = true;
            }
            endSave() {
                this.saving = false;
                this.validation.loading = false;
                this.$qui.scopeApply(this.scope);
            }
            isBreakQuickEntry(form) {
                var _a;
                if (form.typeId !== Roster.Constants.DEVIATION_TYPE_BREAK || this.deviationFormState !== 'new')
                    return false;
                const parentDate = (_a = this.parentServiceForm) === null || _a === void 0 ? void 0 : _a.dateFrom;
                if (!parentDate)
                    return false;
                return moment(form.dateFrom).isSame(parentDate, 'day') && moment(form.dateTo).isSame(parentDate, 'day');
            }
            buildCreatePayload(form) {
                var _a, _b, _c;
                const dateFrom = this.isBreakQuickEntry(form)
                    ? this.$qui.addTimeToDate(this.parentServiceForm.dateFrom, form.timeFrom)
                    : this.$qui.addTimeToDate(form.dateFrom, form.timeFrom);
                const dateTo = this.isBreakQuickEntry(form)
                    ? this.$qui.addTimeToDate(this.parentServiceForm.dateFrom, form.timeTo)
                    : this.$qui.addTimeToDate(form.dateTo, form.timeTo);
                return {
                    dateFrom,
                    dateTo,
                    caption: form.caption,
                    captionShort: form.captionShort,
                    color: form.color,
                    comment: (_a = form.comment) !== null && _a !== void 0 ? _a : '',
                    instituteId: form.instituteId,
                    break: (_b = form.break) !== null && _b !== void 0 ? _b : 0,
                    typeId: form.typeId,
                    additionalWvIds: (_c = form.additionalWvIds) !== null && _c !== void 0 ? _c : []
                };
            }
            buildValidationPayload(form) {
                var _a;
                const payload = this.buildCreatePayload(form);
                return {
                    id: this.deviationFormState === 'edit' ? form.objectId : null,
                    dateFrom: payload.dateFrom,
                    dateTo: payload.dateTo,
                    instituteId: form.instituteId,
                    break: (_a = form.break) !== null && _a !== void 0 ? _a : 0,
                    typeId: form.typeId,
                    conflictProposedAction: this.deviationFormState === 'edit' ? 1 : 0
                };
            }
            getValidationServiceId() {
                var _a, _b, _c;
                return (_b = (_a = this.validationServiceId) !== null && _a !== void 0 ? _a : this.serviceId) !== null && _b !== void 0 ? _b : (_c = this.parentServiceForm) === null || _c === void 0 ? void 0 : _c.parentId;
            }
            validateDeviationForm(showBox = true) {
                if (!DEVIATION_CLIENT_VALIDATION_ENABLED) {
                    this.validation.errors = [];
                    this.validation.warnings = [];
                    return;
                }
                const validationServiceId = this.getValidationServiceId();
                if (!validationServiceId || validationServiceId === QMC.Common.Constants.GUID_EMPTY || !this.deviationForm) {
                    this.validation.errors = [];
                    this.validation.warnings = [];
                    return;
                }
                this.validation.loading = true;
                this.rosterService.validateDeviations(validationServiceId, [this.buildValidationPayload(this.deviationForm)]).then((result) => {
                    this.validation.errors = this.normalizeValidationMessages(result === null || result === void 0 ? void 0 : result.errors);
                    this.validation.warnings = this.normalizeValidationMessages(result === null || result === void 0 ? void 0 : result.warnings);
                }).finally(() => {
                    this.validation.loading = false;
                    this.$qui.scopeApply(this.scope);
                });
            }
            saveDeviation() {
                if (!this.deviationForm || this.saving)
                    return;
                if (this.isInvalidDateRange())
                    return;
                if (!DEVIATION_CLIENT_VALIDATION_ENABLED) {
                    this.beginSave();
                    this.persistDeviation();
                    return;
                }
                const validationServiceId = this.getValidationServiceId();
                if (!validationServiceId || validationServiceId === QMC.Common.Constants.GUID_EMPTY) {
                    this.beginSave();
                    this.persistDeviation();
                    return;
                }
                this.beginSave();
                this.rosterService.validateDeviations(validationServiceId, [this.buildValidationPayload(this.deviationForm)]).then((result) => {
                    this.validation.errors = this.normalizeValidationMessages(result === null || result === void 0 ? void 0 : result.errors);
                    this.validation.warnings = this.normalizeValidationMessages(result === null || result === void 0 ? void 0 : result.warnings);
                    if (this.validation.errors.length > 0) {
                        this.endSave();
                        return;
                    }
                    if (this.validation.warnings.length > 0 && !this.ignoreWarnings) {
                        this.ignoreWarnings = true;
                        this.endSave();
                        return;
                    }
                    this.persistDeviation();
                }).catch(() => {
                    this.endSave();
                });
            }
            normalizeValidationMessages(messages) {
                if (!messages)
                    return [];
                if (Array.isArray(messages))
                    return messages;
                return Object.keys(messages).map(key => messages[key]);
            }
            persistDeviation() {
                var _a, _b;
                if (!this.deviationForm || this.isInvalidDateRange()) {
                    this.endSave();
                    return;
                }
                const payload = this.buildCreatePayload(this.deviationForm);
                const storedDeviation = {
                    ...this.deviationForm,
                    dateFrom: payload.dateFrom,
                    dateTo: payload.dateTo,
                    typeCaption: this.getTypeCaption(this.deviationForm.typeId)
                };
                if (this.formState === 'new') {
                    if (this.deviationFormState === 'new') {
                        this.pendingDeviations = [...((_a = this.pendingDeviations) !== null && _a !== void 0 ? _a : []), storedDeviation];
                    }
                    else {
                        this.pendingDeviations = ((_b = this.pendingDeviations) !== null && _b !== void 0 ? _b : []).map(x => x.objectId === storedDeviation.objectId ? storedDeviation : x);
                    }
                    this.deviations = this.pendingDeviations;
                    this.closeDeviationModal();
                    this.$qui.scopeApply(this.scope);
                    return;
                }
                const savePromise = this.deviationFormState === 'new'
                    ? this.rosterService.postDeviation(this.serviceId, payload)
                    : this.rosterService.putDeviation(this.serviceId, this.deviationForm.objectId, payload);
                savePromise.then(() => {
                    this.closeDeviationModal();
                    this.loadDeviations();
                }).catch(() => {
                    this.endSave();
                });
            }
            deleteDeviation(deviation) {
                var _a;
                if (!((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.delete))
                    return;
                this.promptOptions.itemText = `${deviation.caption} (${moment(deviation.dateFrom).format('DD.MM.yyyy HH:mm')} - ${moment(deviation.dateTo).format('DD.MM.yyyy HH:mm')})`;
                QMC.Common.Utilities.confirm(this.promptOptions, (confirmed) => {
                    var _a;
                    if (!confirmed)
                        return;
                    if (this.formState === 'new') {
                        this.pendingDeviations = ((_a = this.pendingDeviations) !== null && _a !== void 0 ? _a : []).filter(x => x.objectId !== deviation.objectId);
                        this.deviations = this.pendingDeviations;
                        this.$qui.scopeApply(this.scope);
                        return;
                    }
                    this.loading = true;
                    this.rosterService.deleteDeviation(this.serviceId, deviation.objectId).then(() => {
                        this.loadDeviations();
                    }).finally(() => {
                        this.loading = false;
                        this.$qui.scopeApply(this.scope);
                    });
                }, `#deviationPrompt_${this.id}`);
            }
        }
        angular.module('QMC.Roster').component('qmServiceDeviationTab', {
            templateUrl: './Roster/ServiceDeviationTab',
            controller: ['$scope', 'RosterService', '$qui', 'QmcLanguageService', ServiceDeviationTabDirective],
            controllerAs: 'vm',
            bindings: {
                serviceId: '<',
                validationServiceId: '<',
                parentServiceForm: '<',
                formState: '<',
                pendingDeviations: '=',
                breakDeviationSummary: '=',
                permissions: '<',
                serviceSubTypes: '<',
                serviceAdditionals: '<',
                institutes: '<'
            }
        });
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        /**
         * Time tracking user interface class
         */
        class UserInterfaceTimeTracking extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                this.showMonthFilter = true;
                /**
                 * time tracking item list table / only testing purpose right now, NOT final
                 * @memberof UserInterface
                 */
                this.timeTrackingListTable = {
                    "config": {
                        "defaultSort": "timeStamp",
                        "sortReverse": "true"
                    },
                    "filter": {
                        model: null
                    },
                    "table": {
                        "Stempeldatum": {
                            "label": "timeStamp",
                            "dType": "Date",
                            "lngTag": "0"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "0"
                            }]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-clock"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "timeStamp",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "0"
                            }
                        ]
                    },
                    "data": null
                };
            }
        }
        Roster.UserInterfaceTimeTracking = UserInterfaceTimeTracking;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        class TimeTrackingConstants {
        }
        TimeTrackingConstants.TIME_TRACKING_STAMP_IN = '829F4DFB-F4E0-4921-8AC1-8C4F83952593';
        TimeTrackingConstants.TIME_TRACKING_STAMP_OUT = '04C5C2E9-1485-4466-BF46-DE4428DD3DA7';
        Roster.TimeTrackingConstants = TimeTrackingConstants;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        let TimeTrackingService = class TimeTrackingService extends QMC.Common.BaseService {
            constructor() {
                super(...arguments);
                this.timeTrackingPath = '/TimeTracking';
            }
            checkTimeTrackingAvailable() {
                return super.getItem(this.timeTrackingPath + '/CheckAvailable').then((data) => {
                    return data;
                });
            }
            getLatestTimeTrackingDetailItem() {
                return super.getItem(this.timeTrackingPath + '/GetLatest').then((data) => {
                    return data;
                });
            }
            postTimeTrackingStart(comment) {
                return super.post(this.timeTrackingPath + '/Start', { comment }).then((data) => {
                    return data;
                });
            }
            postTimeTrackingStop(comment) {
                return super.post(this.timeTrackingPath + '/Stop', { comment }).then((data) => {
                    return data;
                });
            }
            getTimeTrackingItemList() {
                return super.get(this.timeTrackingPath, { page: -1, pageSize: -1 }).then((data) => {
                    return data.items;
                });
            }
        };
        TimeTrackingService = __decorate([
            QMC.Service('QMC.Roster', 'TimeTrackingService'),
            QMC.Inject('$http', '$q')
        ], TimeTrackingService);
        Roster.TimeTrackingService = TimeTrackingService;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Roster/qmc.roster.js.map
